import { market } from "../market/vi";
import { invite } from '../invite/vi';
import { property } from '../property/vi';
import {advertise} from '../advertise/vi';
import {login, download} from '../login/vi';
import {trading} from '../trading1/vi';
import { contest } from "../contest/vi";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/vi";

import { games } from '../games/vi';
import { taskCenter } from '../task/vi'
import { ieo } from "../ieo/vi";
import { earn } from "../earn/vi";
import { apis } from "../api/vi";
import { tradingContest } from "../tradingContest/vi";
import { agent } from "../agent/vi";
import { live } from "../live/vi";
import { hongbao } from "../hongbao/vi";
const time = {
    r: "ngày",
    s: "giờ",
    f: "phút",
    m: "giây",
};
// 状态
const state = {
    preheatIng: "Đang chuẩn bị",
    purchaseIng: "Đang mua sắm",
    over: "Đã kết thúc",
    finish: "Đã hoàn thành",
    noData: "Chưa có dữ liệu",
    process: "Đang hỗ trợ",
    sellout: "Đã bán hết",
};
// 模板文字
const text = {
  now: "Đang diễn ra",
  start: "Còn lại thời gian đến lượt bắt đầu",
  end: "Còn lại thời gian đến lượt kết thúc",
  jd: "Tiến độ lượt này",
  complete: "Đã hoàn thành",
  limited: "Giá giảm giá giới hạn",

  finish: "Đã hoàn thành",
  subscribing: "Đang đăng ký",
  subscribeNow: "Đăng ký ngay",
  buyStart: "Còn lại thời gian đến đăng ký bắt đầu",
  buyEnd: "Còn lại thời gian đến đăng ký kết thúc",
  projectAmount: "Số lượng dự án",
  quota: "Mỗi phần giới hạn",
  buyPrice: "Giá đăng ký",
  buyLimit: "Giới hạn đăng ký",
  buyAmount: "Số lượng đăng ký",
  buyPos: "Vị thế đăng ký",
  startDate: "Thời gian bắt đầu",
  endDate: "Thời gian kết thúc",
  projectSuppot: "Hỗ trợ dự án",
  websit: "Trang web dự án",
  projectDetail: "Chi tiết dự án",
  cycle: "Chu kỳ đăng ký",
  all: "Tất cả",
  step1: "Đợt bắt đầu",
  step2: "Đăng ký",
  step3: "Bốc thăm",
  step4: "Công bố kết quả",
  subOrder: "Đơn đăng ký",
  myOrder: "Đơn trúng thầu",
  proCoin: "Loại tiền dự án",
  buyCoin: "Loại tiền đăng ký",
  orderDate: "Thời gian đơn hàng",
  issuanceQuota: "Số lượng phát hành",
  dealAmount: "Số lượng giao dịch",
  dealPrice: "Giá trị giao dịch",
  status: "Trạng thái",
  ctrl: "Thao tác",
  checkOrder: "Kiểm tra số đơn",
  subNum: "Số đơn đăng ký",
  myNum: "Số đơn trúng thầu",
  status0: "Đã đăng ký",
  status1: "Đợi trừ tiền",
  status2: "Đã hoàn thành",
  conditionTerm1: "Trước thời gian đăng ký * ngày,",
  conditionTerm2: "Giao dịch cặp *",
  conditionTerm3: "Tất cả các cặp giao dịch",
  conditionTerm4: "Tổng giá trị giao dịch (USDT) tích lũy đạt được mỗi * có thể đăng ký 1 phần",
  noData: "Chưa có dữ liệu",
  qgsc: "Khóa đăng ký",
  yhsg: "Bốc thăm đăng ký",
  sgsb: "Đăng ký thất bại",

  supply: "Số lượng cung",
  rate: "Tỷ lệ đổi",
  ceiling: "Giới hạn hỗ trợ",
  xmwc: "Dự án đã hoàn thành",
  xmze: "Tổng giá trị dự án",
  zkjj: "Giá giảm giá trung bình",
  cyrs: "Số người tham gia",
  round: "Vòng thứ [*]",
  r: "người",
  cgqg: "Đăng ký thành công",
  cgzl: "Hỗ trợ thành công",
  xmed: "Số lượng dự án",
  kszl: "Thời gian bắt đầu hỗ trợ",
  ksqg: "Thời gian bắt đầu đăng ký",
  jsqg: "Thời gian kết thúc đăng ký",
  jszl: "Thời gian kết thúc hỗ trợ",
  hdgz: "Quy tắc hoạt động",
  xmjs: "Giới thiệu dự án",
  tcqr: "Sau khi bạn xác nhận thanh toán, bạn có thể mất cơ hội tham gia hoạt động đăng ký này. Hãy cân nhắc cẩn thận!",
  jxtc: "Tiếp tục thoát",
  fhzf: "Quay lại thanh toán",
  qgrsd: "Hiện tại có nhiều người đăng ký, đang nỗ lực đăng ký, vui lòng chờ đợi!",
  zltcqr: "Sau khi bạn xác nhận thanh toán và thoát, bạn có thể mất cơ hội tham gia hoạt động hỗ trợ này. Hãy cân nhắc cẩn thận!",
  zlqgrsd: "Hiện tại có nhiều người hỗ trợ, vui lòng chờ đợi!",
  wxts: "Lưu ý: Vui lòng xác nhận thanh toán càng sớm càng tốt, nếu không thanh toán trong [*] phút, có thể quá thời gian và cửa sổ sẽ đóng.",
};

const seckill = {
    sgno: "Bạn chưa đáp ứng điều kiện đăng ký",
    srjymm: "Vui lòng nhập mật khẩu giao dịch",
    ljzf: "Thanh toán ngay",
};
const apply = {
    condition: "Điều kiện đăng ký",
    apply: "Đăng ký ngay",
    buyPrice: "Giá đăng ký",
    buyAmount: "Số lượng đăng ký",
    applyAmount: "Giá trị đăng ký",
    forget: "Quên mật khẩu giao dịch?",
    noAmount: "Vui lòng nhập số lượng đăng ký",
    buyLimit: "Giới hạn đăng ký",
    success: "Đăng ký thành công!",
    paySummary: "Lưu ý: Vui lòng xác nhận thanh toán càng sớm càng tốt, <b>trong vòng 3 phút</b> nếu không hoàn thành thanh toán, cửa sổ sẽ đóng",
    appFull: "Số lượng đăng ký quá lớn",
    seckill_async_fail_13: "Khoảng thời gian giữa hai lần đăng ký là {} phút",
};

const seckillRes = {
    seckill_async_3: "Đang thanh toán, vui lòng đợi!",
    seckill_async_5: "Hủy thành công",
    seckill_async_fail_1: "Xin lỗi! Vui lòng làm mới trang và thử lại!",
    seckill_async_fail_2: "Xin lỗi! Vui lòng làm mới trang và thử lại!",
    seckill_async_fail_3: "Xin lỗi! Vui lòng làm mới trang và thử lại!",
    seckill_async_fail_4: "Xin lỗi! Số lượng đã hết!",
    seckill_async_fail_5: "Xin lỗi! Thanh toán đã quá thời gian, vui lòng thử lại!",
    seckill_async_fail_6: "Sai mật khẩu thanh toán, vui lòng nhập lại!",
    seckill_async_fail_7: "Số lần nhập sai mật khẩu giao dịch vượt quá giới hạn, vui lòng thử lại sau!",
    seckill_async_fail_8: "Xin lỗi! Thanh toán đã quá thời gian, vui lòng thử lại!",
    seckill_async_fail_9: "Xin lỗi! Số lượng đã hết, mong bạn sẽ thành công lần sau!",
    seckill_async_fail_10: "Hiện có nhiều người đăng ký, vui lòng đợi một chút rồi thử lại!",
    seckill_async_fail_11: "Xác nhận hành động thất bại!",
};
const header = {
    zcgl: "Quản lý tài sản",
    zczh: "Tài khoản tài sản",
    bbzh: "Tài khoản tiền mã hóa",
    fbzh: "Tài khoản mua tiền",
    bdbzh: "Tài khoản BiDaiBao",
    wdgl: "Quản lý lệnh đặt",
    lswt: "Lệnh đặt lịch sử",
    qbhz: "Chuyển đổi ví",
    yhzx: "Trung tâm người dùng",
    wdhb: "Ví hồng của tôi",
    openOrder: "Lệnh đặt hiện tại",
    dealStats: "Thống kê giao dịch",
    totalAsset: "Tổng giá trị tài sản",
    cz: "Tài khoản hợp đồng",
    gmcnyt: "Mua CNYT",
    yqfy: "mời",
    hbthhr: "Đối tác HBT",
    tczh: "Đăng xuất tài khoản",
    moreNew: "Thông báo khác",
    gfgg: "Thông báo chính thức",
    zxxw: "Tin tức mới nhất",
    ckgd: "Xem thêm",
    bbdd: "Đơn đặt hàng tiền mã hóa",
    bbwhydd: "Đơn đặt hàng hợp đồng vĩnh viễn",
    etfdd: "Đơn đặt hàng ETF",
    fbdd: "Đơn đặt hàng tiền tệ",
};

const recommend = {
    vol24h: "Khối lượng 24H",
    jyd: "Cặp giao dịch",
    jydlx: "Loại cặp giao dịch",
    zxj: "Giá mới nhất",
    change24: "Biến động 24H",
    line24: "Xu hướng giá (3 ngày)",
};

const hyy = {
    ty: "Đồng ý",
    bkt: "Không mở",
    wqdkt: "Tôi xác nhận mở",
    kt12: "1. Trước khi tham gia, bạn cần hiểu rõ kiến thức cơ bản về giao dịch hợp đồng tiền điện tử và rủi ro liên quan, cũng như các quy tắc kinh doanh liên quan đến giao dịch sản phẩm phái sinh.",
    kt13: "2. Cảnh báo về rủi ro trong tuyên bố này chỉ mang tính chất liệt kê và không liệt kê đầy đủ tất cả các yếu tố rủi ro liên quan đến giao dịch sản phẩm phái sinh của tài sản số. Trước khi đầu tư vào giao dịch sản phẩm phái sinh của tài sản số, nhà đầu tư cũng nên cân nhắc và hiểu rõ về các yếu tố rủi ro khác có thể tồn tại.",
    kt14: "3. Chúng tôi chân thành hy vọng và khuyến nghị nhà đầu tư, từ tình hình thực tế của bản thân như khả năng chịu đựng rủi ro, hãy quyết định tham gia giao dịch hợp đồng này một cách cẩn thận và cân nhắc việc cấu hình hợp lý về tài sản số của chính họ.",
    kt0: "Quý khách thân mến:",
    kt1: "Quý khách chưa mở tài khoản hợp đồng và quyền giao dịch hợp đồng, vui lòng đọc kỹ nội dung dưới đây trước khi quyết định mở:",
    kt2: "Một, khi quý khách thực hiện giao dịch trên thị trường hợp đồng, nếu xu hướng giá thị trường không thuận lợi đối với quý khách và dẫn đến không đủ tiền đặt cọc vị thế của quý khách, hợp đồng vô hạn BiKing sẽ thực hiện đặt lệnh bán đảm bảo và tiết lộ chi tiết bán đảm bảo.",
    kt3: "Hai, quý khách phải đọc kỹ và tuân thủ các quy tắc kinh doanh của hợp đồng vô hạn BiKing, hiểu rõ cơ chế và nguyên lý hoạt động của hợp đồng, và nắm rõ mọi rủi ro của thị trường.",
    kt4: "Bốn, Hợp đồng vô hạn BiKing kết nối với hệ thống giao dịch hợp đồng, lợi nhuận và lỗ của vị thế người dùng sẽ biến động theo biến động thị trường hợp đồng. Khi lỗ lớn, người dùng cũng có thể bị phá sản trong hệ thống giao dịch hợp đồng. Xin vui lòng quyết định hành động giao dịch của quý khách dựa trên tình hình thị trường hợp đồng, tự chịu trách nhiệm về lợi nhuận và lỗ, và do đó, BiKing không chịu trách nhiệm về bất kỳ trách nhiệm ước định hoặc đã định nào.",
    kt5: "Năm, vui lòng tuân thủ các quy tắc liên quan của nền tảng và tuân thủ các quy định pháp luật của các quốc gia và vùng lãnh thổ liên quan. Nếu tài khoản hợp đồng của người dùng bị đóng băng do hoạt động vi phạm quy định, họ sẽ không thể thực hiện các giao dịch và nền tảng cũng không thể thực hiện việc giải quyết vị thế. Nếu điều này gây thất thoát hoặc phá sản, nền tảng sẽ không chịu trách nhiệm cho điều này.",
    kt6: "Sáu, giao dịch sản phẩm phái sinh của tài sản số có thể đối mặt với rủi ro giám sát chính sách trong một số lãnh thổ pháp luật nhất định. Trước khi giao dịch, bạn cần thận trọng đưa ra quyết định dựa trên việc hiểu biết về bối cảnh giám sát chính sách tại khu vực giao dịch. Do thay đổi về pháp luật, quy định và chính sách của các quốc gia và vùng lãnh thổ liên quan, cũng như sự thay đổi trong các quy tắc giao dịch hợp đồng, BiKing sẽ thông báo trước, vị thế chưa được giải nguyên cũng có thể không tiếp tục giữ, nhưng tiền đặt cọc và số lợi nhuận sẽ vẫn được thanh toán.",
    kt7: "Bảy, do các lý do mà bên ngoài bên kiểm soát của nền tảng, chẳng hạn như: động đất, lũ lụt, hỏa hoạn và các yếu tố không thể dự đoán khác hoặc sự cố trong hệ thống máy tính, hệ thống liên lạc, có thể dẫn đến việc lệnh của bạn không thể thực hiện hoặc không thể thực hiện đầy đủ, có thể gây thiệt hại và bạn có thể phải chịu trách nhiệm cho nó.",
    kt8: "Tám, giao dịch 'bảo hiểm giá' giống như giao dịch đầu cơ, cũng đối mặt với rủi ro do biến động giá.",
    kta9: "Chín, nếu bạn không thực hiện xác minh danh tính hoặc không liên kết xác minh Google, hoặc cho phép người khác sử dụng tài khoản không phải của họ, điều này có thể ảnh hưởng đến tính an toàn của tiền đặt cọc hợp đồng của bạn.",
    kta10: "Ba, trong một số trường hợp thị trường cực đoan, bạn có thể khó khăn hoặc không thể đóng bất kỳ hợp đồng chưa giải nguyên nào bạn đang giữ. Ví dụ, khi lợi nhuận của bạn đứng đầu trong toàn bộ thị trường hợp đồng có đòn bẩy hiệu quả và đối tác ngược không đủ tiền để thanh toán số lỗ do việc chốt lỗ.",
    kt9: "Tôi đã đọc kỹ và sẵn lòng chịu trách nhiệm",
    kt10: "Mở tài khoản và quyền giao dịch hợp đồng",
    zjhz: "Chuyển vốn",
    ljhz: "Chuyển ngay",
    qx: "Hủy chuyển",
    khz: "Có thể chuyển",
    qxz: "Vui lòng chọn",
    bz: "Loại tiền",
    c: "Từ",
    zz: "Đến",
    sl: "Số lượng",
    qb: "Toàn bộ",
    ktcg: "Mở thành công",
    ktsb: "Mở thất bại",
    hzcg: "Chuyển thành công",
    hzsb: "Chuyển thất bại",
    wyyd: "", //Chưa đánh dấu ô đọc thông báo văn bản
    tc: "Thoát",
    warning1: "Vui lòng chọn loại tiền",
    warning2: "Tài khoản chuyển ra không thể để trống",
    warning3: "Tài khoản chuyển vào không thể để trống",
    warning4: "Vui lòng nhập số không lớn hơn số có thể chuyển",
    warning5: "Tối đa 4 chữ số thập phân",
    gb: "Đóng",
    openSuccess: "Bạn đã mở giao dịch hợp đồng",
    openSuccessTip: "Vui lòng chuyển vốn vào tài khoản hợp đồng",
    wsmyz: "Bạn chưa hoàn thành xác minh danh tính",
    hdnm: "Hoàn thành xác minh danh tính và tích lũy Chuyển vốn ròng [*] USDT có thể nhận được mã bùn [**] USDT",
    nmjl: "Ghi chú về Mã bùn",
    nmhzjl: "Lịch sử nhận Mã bùn",
    gxn: "Chúc mừng bạn!",
    qwjy: "Chuyển đến giao dịch",
    yfrndhyzh: "Đã chuyển vào tài khoản hợp đồng của bạn",
    nzxy: "Bạn chỉ cần chuyển thêm [*] USDT vào tài khoản hợp đồng để nhận được [**] USDT mã bùn",
    nmssm: "Mã bùn là gì",
    nm: "Mã bùn",
    nxhyzh: "Bạn đã chuyển vào tài khoản hợp đồng",
    text1: "Tích lũy Chuyển vốn ròng [*] USDT trở lên vào tài khoản hợp đồng để nhận",
    text2: "Bạn chỉ cần chuyển thêm [*] USDT vào tài khoản hợp đồng",
    text3: "để nhận mã bùn [**] USDT",
    text4: "Số dư",
    text5: "Bạn đã tích lũy Chuyển vốn ròng [*] USDT trở lên và đã nhận được",
    not_get_nm: "Xin lỗi, hoạt động mã bùn đã kết thúc, lần chuyển vốn này không nhận được mã bùn",
    yijie: "1, cấp 1",
    erjie: "2, cấp 2",
    ljjhr: "Tích lũy Chuyển vốn ròng",
    khd: "Có thể nhận được",
    hysnm: "Hợp đồng tặng mã bùn",
    bbgg: "Hợp đồng vô hạn đòn bẩy 100",
    hdsj: "Thời gian hoạt động:",
    hdxq: "Chi tiết hoạt động",
    ljhd: "Nhận ngay",
    xdxd: "Ai đến trước được trước",
    ylnnz: "Thắng bạn mang về, thua rồi coi như tôi chịu",
};

const Verification = {
    channel: "Kênh Xác nhận Chính thức",
    verify: "Vui lòng nhập thông tin cần xác nhận",
    notes: "Lưu ý An toàn",
    notes1:"1. Tất cả các thông tin liên quan đến BiKing như địa chỉ email, WeChat, số QQ, tên miền và số truyền thông đều có thể được xác nhận ở đây.",
    notes2: "2. Tài khoản truyền thông xã hội (Weibo, Twitter, v.v.) chỉ hỗ trợ tra cứu theo tên, cần phân biệt chữ hoa chữ thường.",
    notes3: "3. Nếu có thắc mắc về kết quả xác nhận, bạn có thể liên hệ với dịch vụ khách hàng chính thức qua trang web hoặc ứng dụng để được xác nhận một lần nữa.",
    error: "Xác nhận thất bại",
    error1: "Thông tin bạn tra cứu",
    error2: "không phải là kênh xác nhận chính thức, vui lòng chú ý bảo vệ tài sản và tránh rò rỉ thông tin cá nhân.",
    errorNote: "Lưu ý",
    errorNote1:"1. Hiện tại, kênh xác nhận chính thức chỉ hỗ trợ xác nhận địa chỉ email, tài khoản WeChat chính thức, số QQ, tên miền và tài khoản truyền thông xã hội.",
    errorNote2: "2. Các công cụ nhắn tin như WeChat chỉ hỗ trợ tra cứu theo tài khoản (không phải là biệt danh)",
    errorNote3: "3. Tài khoản truyền thông xã hội chỉ hỗ trợ tra cứu theo tên, cần phân biệt chữ hoa chữ thường",
    success: "Xác nhận thành công",
    success1: "Thông tin bạn tra cứu:",
    success2: "được xác nhận là chính thức của BiKing",
    success3: "Nếu số điện thoại/tài khoản này xuất hiện ở kênh khác, vui lòng không tin tưởng, hãy chú ý đến an toàn tài sản.",
    more: "Xem thêm",
    know: "Tôi đã biết",
    weChat: "WeChat",
    name: "Tên miền",
    webo: "Weibo",
    twitter: "Twitter",
    email: "Email",
    contact: "Liên hệ dịch vụ khách hàng",
    bannerTip:"Để ngăn chặn các đối tượng phạm tội lợi dụng tên của BiKing để lừa đảo, bạn có thể xác nhận thông tin như số điện thoại, WeChat, v.v. có phải là kênh chính thức của BiKing hay không thông qua trang này.",
};
const index = {
    downloadIos: 'Tải về từ AppStore',
    downloadAndroid: 'Tải về cho Android',
    downloadGoogle: 'Tải về từ Google Play'
};

const indexPage = {
    gfgg: "Thông báo chính thức",
    zxxw: "Tin tức mới nhất",
    ckgd: "Xem thêm",
};

const NAVS = {
    ty: 'Euro',
    hqsj: 'Thị trường',
    game: 'Trò chơi',
    xh: 'Tiền mặt',
    hhjy: 'Giao dịch swap',
    fx: 'Khám phá',
    sj: 'Dữ liệu',
    fb: "Mua coin",
    bb: "Giao dịch tiền mặt",
    jr: "kiếm",
    jyds: "Cuộc thi giao dịch",
    hbhd: "Sự kiện lì xì",
    gg: "Giao dịch đòn bẩy",
    yxhy: "Hợp đồng vô hạn",
    eft: "Giao dịch ETF",
    flhd: "Hoạt động phúc lợi",
    flzx: "Phúc lợi",
    fast: "Giao dịch nhanh",
    spec: "Giao dịch chuyên nghiệp",
    login: "Đăng nhập",
    rig: "Đăng ký",
    downapp: "Tải về ứng dụng BiKing",
    downappsum: "Trải nghiệm mượt mà, Nạp/rút trong tích tắc",
    zichan: "Tài sản",
    order: "Đơn hàng",
    qbhz: "Chuyển ví",
    lang: "Ngôn ngữ",
    calc: "định giá",
  
    mb: "Mua coin",
    hq: "Thị trường",
    hy: "Hợp đồng",
    jy: "Giao dịch",
    lc: "Kiếm coin",
    fs: "Fansup",
    xy: "Học viện",
    byxy: "Học viện BiKing",
    byyx: "Chọn lọc BiKing",
    coins: "Điểm COINS",
    gd: "Thêm",
    yqhy: "Mời bạn bè",
    rwzx: "Trung tâm nhiệm vụ",
    bbms: "Mua các loại tài sản số như Bitcoin bằng USDT",
    ggms: "Cho mượn tài sản số trên nền tảng, tăng lợi nhuận và rủi ro",
    yxms: "Hỗ trợ đòn bẩy lên đến 100 lần, thao tác thuận lợi và đa dạng",
    etfms: "Tăng lợi nhuận, không có rủi ro bùng nổ",
    pool: "Hồ chia sẻ",
    czzn: 'Hướng dẫn sử dụng',
    gywm: 'Về chúng tôi',
    zhxx: 'Thông tin tài khoản',
    gd:"Theo dõi",
    yxhy: "Hợp đồng vô hạn",
    zjhy: "Hợp đồng tặng",
    product: "sản phẩm",
};

const FOOTERS = {
    zxkf: "Hỗ trợ trực tuyến",
    fawu: "Lời khuyên pháp lý",
  
    us: "Chúng tôi",
    product: "Sản phẩm",
    service: "Dịch vụ",
    college: "Học viện",
  
    aboutUs: "Về chúng tôi",
    rateSum: "Giải thích phí",
    notices: "Trung tâm thông báo",
    helps: "Trung tâm trợ giúp",
    verific: "Kênh xác nhận chính thức",
    contact: "Liên hệ chúng tôi",
  
    fabi: "Mua coin",
    bibi: "Giao dịch coin",
    ganggan: "Giao dịch đòn bẩy",
    swiper: "Hợp đồng vô hạn",
    etf: "Giao dịch ETF",
    licai: "Kiếm coin",
  
    apis: "Hỗ trợ API",
    apisNew: "Hỗ trợ API",
    addCoin: "Đề xuất thêm coin",
    vips: "Quyền lợi VIP",
    downapp: "Tải ứng dụng",
    files: "Tài liệu pháp lý",
  
    newuser: "Chương trình mới của BiKing",
    swiperSchool: "Học viện Hợp đồng",
    assistant: "Trợ lý học tập",
    digitalintroduction: "Giới thiệu tài sản số",
  
    watchword: "Nền tảng giao dịch xanh hàng đầu thế giới",
    meiyitian: "Mỗi ngày, tạo ra tài sản",
    chat: "Phòng trò chuyện",
    shequncn: "Cộng đồng Telegram tiếng Trung",
    shequnen: "Cộng đồng Telegram tiếng Anh",
    shequnkr: "Cộng đồng Telegram tiếng Hàn"
};

const SIDEBAR = {
    newuser: "Người mới",
    guide: "Hướng dẫn",
    bbsq: "Cộng đồng giao dịch coin",
    hysq: "Cộng đồng hợp đồng",
    gd: "Cố định",
    sq: "Thu gọn"
};

const banner = {
    wzwh: 'Sử dụng trang web Biking và/hoặc duy trì tài khoản của bạn chỉ ra sự đồng ý của bạn với chúng tôi cập nhật',
    sytk: 'Điều Khoản Sử Dụng',
    yszc: 'Chính Sách Bảo Mật',
    hh: 'và',
    cookie: 'Chính Sách Cookie',
    djgb: 'Nhấp vào “X” cho biết bạn nhận thức rằng bạn đã đọc và đồng ý với các điều khoản và chính sách trên.',
    
    title: 'Nền tảng giao dịch và trò chơi tiền điện tử đa dạng',
    marketTitle: 'Giao dịch tiền điện tử Chúng tôi là chuyên gia',
    marketSubTitle: 'Cam kết cung cấp dịch vụ giao dịch sản phẩm phái sinh tiền điện tử an toàn và ổn định hơn cho người dùng',
    pathTitle: 'Người trợ lý đáng tin cậy trên hành trình tiền điện tử của bạn',
    pathSubTitle: 'Lựa chọn của hàng triệu người dùng, nền tảng đáng tin cậy đáng tin cậy',
    jylz: '3,000 tỷ đô la',
    jyl: 'Khối lượng giao dịch trong vòng 72 giờ',
    sxs: 'Tiền điện tử đã được niêm yết',
    zcyh: 'Người dùng đăng ký',
    zdjy: 'Phí giao dịch tối thiểu',
    connectTitle: 'Tại sao chọn chúng tôi',
    connectSubTitle: 'BiKing giúp bạn tạo ra, tăng giá trị và bảo quản tài sản',
    advantageText1: 'Hiệu suất hàng đầu · Giao dịch siêu tốc',
    advantageSubText1: 'Động cơ của Sở giao dịch Chứng khoán London, độ trễ siêu thấp, đối kháng cực nhanh',
    advantageText2: 'Bảo vệ tài sản · An toàn tuyệt đối',
    advantageSubText2: 'BiKing tuân thủ tiêu chuẩn CCSS, bảo vệ an toàn tài sản và dữ liệu',
    advantageText3: 'Thanh khoản cao · Spread thấp',
    advantageSubText3: 'Giao dịch đòn bẩy BiKing, hiệu quả cao, độ trượt tối thiểu',
    advantageText4: 'Dịch vụ 24/7',
    advantageSubText4: 'Đảm bảo hệ thống hoạt động bình thường, cung cấp dịch vụ khách hàng 24/7',
    advantageText5: 'Tiện lợi và dễ sử dụng',
    advantageSubText5: 'Cung cấp nhiều hệ thống đặt hàng và công cụ giao dịch, rủi ro có thể kiểm soát',
    advantageText6: 'Bất cứ nơi nào, bất cứ lúc nào · Giao dịch an toàn',
    advantageSubText6: 'Nền tảng BiKing cung cấp phiên bản trang web, ứng dụng di động, kết nối API và FIX',
    netWorkTitle: '26 quốc gia, 1,200,000 người dùng lựa chọn chung',
    netWorkSubTitle: 'Cam kết cung cấp dịch vụ giao dịch sản phẩm phái sinh tiền điện tử an toàn và ổn định hơn cho người dùng',
    smxz: 'Quét mã để tải về',
    fxbzj: 'Tiền đặt cọc rủi ro',
    fkbz: 'Đảm bảo mọi giao dịch đều có bảo hiểm rủi ro vốn toàn diện',
    question1: '1. Giới thiệu về Sàn giao dịch BiKing',
    questionContent1: 'Sàn giao dịch BiKing là một sàn giao dịch tiền điện tử hàng đầu toàn cầu có trụ sở tại Singapore, sở hữu giấy phép hai lớp tại Hoa Kỳ / Canada, cung cấp nhiều dịch vụ như giao dịch, lưu trữ và quản lý tiền điện tử.',
    question2: '2. Sàn giao dịch BiKing cung cấp những sản phẩm nào?',
    questionContent2: 'Sàn giao dịch BiKing cung cấp các sản phẩm sau: Hợp đồng vô hạn - Sâu và nhanh chóng; Giao dịch tiền mặt - Không phí, giao dịch nhanh chóng; Cộng đồng theo dõi - Người giao dịch kinh nghiệm, chiến lược ổn định; Giao dịch tặng - Mô hình duy nhất, không ngừng hưởng lợi; Ví Web - Dịch vụ đa dạng tất cả trong một',
    question3: '3. Làm thế nào để đăng ký tài khoản trên Sàn giao dịch BiKing?',
    questionContent3: 'Bạn có thể đăng ký tài khoản trên trang web chính thức hoặc ứng dụng BiKing. Nhấp vào nút Đăng ký và hoàn tất quy trình đăng ký để có thể sử dụng Sàn giao dịch BiKing để đầu tư và quản lý tiền điện tử.',
    question4: '4. Làm thế nào để mua tiền điện tử thông qua Sàn giao dịch BiKing?',
    questionContent4: 'Sàn giao dịch BiKing hỗ trợ mua tiền điện tử nhanh chóng với nhiều phương thức thanh toán và nhiều loại tiền tệ, mang lại nhiều lựa chọn và tiện lợi cho người dùng trên toàn thế giới, không phụ thuộc vào quốc gia hoặc khu vực nào, đều có thể mua tiền điện tử bằng tiền tệ địa phương một cách dễ dàng.',
    question5: '5. Làm thế nào để thực hiện giao dịch tiền điện tử?',
    questionContent5: 'Bạn có thể chọn tiền điện tử bạn muốn giao dịch trên Sàn giao dịch BiKing, sau đó, khi bạn vào trang giao dịch, chọn mua hoặc bán, nhập số lượng và giá giao dịch, xác nhận giao dịch là có thể. Ngoài ra, Sàn giao dịch BiKing hỗ trợ nhiều loại giao dịch tiền điện tử, bao gồm Bitcoin, Ethereum, Litecoin, Ripple, v.v.',
    question6: '6. Làm thế nào Sàn giao dịch BiKing đảm bảo an toàn tài sản cho người dùng?',
    questionContent6: 'Sàn giao dịch BiKing sử dụng công nghệ mã hóa đa lớp để bảo vệ thông tin và tài sản của người dùng, và sử dụng cách lưu trữ tách biệt giữa ví nóng và ví lạnh để đảm bảo an toàn tài sản của người dùng.',
    investor: '300 triệu nhà đầu tư tiền điện tử tin tưởng',
    transaction: 'Đầu tư, giao dịch và phát triển trên BiKing',
    hypt: 'Nền tảng giao dịch phái sinh tiền điện tử hàng đầu toàn cầu với tiêu chí an toàn',
    yjpc: 'Mở hoặc đóng một lần nhấp',
    jscrj: 'Rút / nạp tiền siêu tốc, bắt đầu giao dịch trong vòng 60 giây, thực sự thực hiện giao dịch không trượt giá',
    zcpt: 'Đăng ký và giao dịch ngay lập tức nhận USDT',
    email: 'Địa chỉ email',
    phone: 'Số điện thoại',
    zc: 'Đăng ký',
    yhjaqbz: 'Đảm bảo an toàn cấp ngân hàng',
    lhdmch: 'Siêu trượt giá 0 giây',
    qthkf: 'Dịch vụ khách hàng 24/7',
    rmjmhb: 'Tiền điện tử phổ biến',
    jrsq: 'Tham gia cộng đồng xe đạp',
    hqzxhd: 'Nhận thông tin sự kiện Đạp xe mới nhất và hỗ trợ trực tuyến',
}
const navCard = {
    join: 'Tham gia BiKing',
    hzdl: 'BiKing币王 hợp tác đại lý ký kết mong đợi sự tham gia của bạn',
    jmrx: 'Đường dây nóng gia nhập đại lý: 183283232998',
    contract: 'Ký kết trực tuyến',
    yxhy: 'BiKing快捷合约 币王雙合約 驚喜上線',
    jylh: 'Giao dịch linh hoạt hơn, thu nhập phong phú hơn',
    usa: 'USA AND CANADA MSB',
    zmjys: 'BiKing币王, sàn giao dịch nổi tiếng quốc tế, đạt được nhiều giấy phép tuân thủ quy định của nhiều quốc gia',
    fxpf: 'Rủi ro là thanh toán, an toàn và đáng tin cậy',
    srhy: 'BiKing đầu tiên vào hợp đồng, tặng 30% vàng thật',
    hdsj: 'Thời gian hoạt động: Từ 00:00 ngày 01 tháng 11 năm 2022 đến 00:00 ngày 01 tháng 12 năm 2022'
}

const choice = {
    gjyh: '26 quốc gia, 1.2 triệu người dùng lựa chọn chung',
    jyfu: 'Cam kết cung cấp dịch vụ giao dịch sản phẩm tài sản mã hóa an toàn và ổn định hơn cho người dùng',
    wsmxzwm: 'Tại sao chọn chúng tôi',
    jsty: 'Trải nghiệm cực kỳ nhanh chóng',
    jmsj: 'Giao diện giao dịch được thiết kế phối hợp với kinh nghiệm vận hành người dùng của nền tảng trong nhiều năm, quy trình rõ ràng, thao tác thuận tiện, kết hợp với công nghệ tổ chức lõi với thời gian đáp ứng chỉ trong mili giây, mang lại trải nghiệm giao dịch thuận lợi và thoải mái cho người dùng.',
    kfx: 'Cơ chế giá chống rủi ro',
    pthybz: 'Giá các loại tài sản mã hóa trong hợp đồng của nền tảng sử dụng thuật toán tích hợp nhiều nguồn, có khả năng kiểm soát rủi ro mạnh mẽ, hiệu quả tránh rủi ro và tổn thất của người dùng dưới mọi tình huống thị trường cực đoan.',
    zjaqbz: 'Đảm bảo an toàn tài chính',
    zjdt: 'Tất cả các chuyển động tài chính đều được hoàn thành với nhiều chữ ký ngoại tuyến, đảm bảo quyết định trong mili giây, lưu trữ tài sản ở nhiệt độ cực thấp, bảo vệ toàn diện tài chính của người dùng, cung cấp một hệ thống kiểm soát rủi ro an toàn cấp ngân hàng đến 100% cho mỗi người dùng.',
    jszc: 'Hỗ trợ kỹ thuật hàng đầu',
    ptjstd: 'Đội ngũ kỹ thuật của nền tảng bao gồm một nhóm chuyên gia hàng đầu về công nghệ chuỗi khối, đảm bảo trải nghiệm tuyệt vời cho người dùng và cung cấp sự hỗ trợ kỹ thuật mạnh mẽ cho sự phát triển và vận hành của nền tảng.',
    jcjz: 'Cơ chế giảm giá theo bậc',
    hqbh: 'Dựa trên biến động thị trường, kích hoạt cơ chế kiểm soát rủi ro giao dịch của người dùng một cách hợp lý, bảo vệ tài sản của họ 24/7.',
    kf: 'Dịch vụ khách hàng 24/7',
    ptkf: 'Nền tảng triển khai hệ thống dịch vụ khách hàng 24/7, nghiêm túc đối mặt với mọi vấn đề mà mỗi người dùng gặp phải.'
}

const plat = {
    ptgn: 'Chức năng nền tảng',
    zjms: 'Chế độ tặng vàng',
    zjjs: 'Chế độ tặng vàng là một chế độ đặc biệt mới dành cho tất cả người dùng hợp đồng trên toàn mạng, do đội ngũ BiKing phát triển và ra mắt đầu tiên. Quy trình hoạt động của chế độ tặng vàng giống như hợp đồng thực tế, phần lợi nhuận thu được khi mở vị trí có thể chuyển sang tài khoản hợp đồng để tiếp tục mở vị trí hoặc rút trực tiếp. Các cách để kiếm vàng bao gồm: hoàn tiền phí ngay lập tức, phân phối thưởng sự kiện, hoàn thành nhiệm vụ và nhiều hơn nữa.',
    zcms: 'Chế độ toàn bộ',
    zcjs: 'Dưới chế độ toàn bộ, tiền đặt cọc và lợi nhuận / lỗ chuyển động của tất cả các vị trí kết nối với nhau và bao gồm tất cả tài sản của tài khoản, bao gồm tiền đặt cọc mở vị trí. Chế độ toàn bộ có khả năng kiểm soát rủi ro mạnh mẽ, nhưng cũng dễ vượt quá dự đoán lỗ.',
    zucms: 'Chế độ từng cửa hàng',
    zucjs: 'Dưới chế độ từng cửa hàng, mỗi lệnh là độc lập, tính toán lợi nhuận và lỗ riêng lẻ dựa trên giá đặt cọc của mỗi vị trí. Khi vốn cổ phiếu (hoặc còn gọi là tiền đặt cọc) của một lệnh giảm đến điểm dừng lỗ tối đa, nó sẽ bị bắt buộc phải đóng cửa. Khi lợi nhuận đạt đến điểm lợi nhuận tối đa, nó sẽ tự động đóng cửa. Khi dưới chế độ từng cửa hàng có lệnh mở hoặc lệnh kế hoạch, bạn sẽ không thể chuyển sang chế độ mở cửa từng cửa hàng.',
    gdgn: 'Chức năng đồng điệu',
    gdjs: 'Khi kích hoạt chức năng đồng điệu, tất cả các hành vi mở và đóng cửa hàng của người bán sẽ được thực hiện đồng bộ, chỉ khi có dư không đủ hoặc vượt quá giới hạn giữ chỗ mới không thể hoàn thành đồng bộ. Nếu không hủy chức năng đồng điệu thủ công, chức năng này sẽ tiếp tục hoạt động.',
    bfpc: 'Chỉ đóng một phần',
    bfjs: 'Khi giữ một lượng nhất định cổ phiếu dài hoặc ngắn, có thể tùy chọn tự do số lượng đóng cửa theo thay đổi thị trường và tình hình lợi nhuận và lỗ. Đồng thời, số tiền lợi nhuận và lỗ của lệnh giữ cổ phiếu cũng sẽ được thanh toán theo tỷ lệ so với tổng số tiền đặt cọc và sau khi đóng cửa, lợi nhuận không thay đổi.',
    fxkc: 'Mở cửa ngược',
    fxjs: 'Hệ thống sẽ tự động giúp bạn đóng ngay lập tức các vị trí đang giữ trong tình trạng hiện tại và mở ra số lượng tương đương của vị trí giữ cổ phiếu ngược hướng với giá thị trường tốt nhất, để tránh bỏ lỡ thị trường đảo chiều hoặc tình hình đảo chiều quá nhanh để mở cửa.',
    zjbzj: 'Bổ sung tiền đặt cọc',
    zjbzjjs: 'Khi giữ một lượng nhất định cổ phiếu dài hoặc ngắn, bạn có thể bổ sung tiền đặt cọc trong tình hình tiền đặt cọc hiện tại của mỗi vị trí, vị trí sau khi bổ sung sẽ được tính toán theo tỷ lệ theo công thức trọng số dựa trên thông số vị trí khi mở cửa và khi bổ sung tiền đặt cọc.'
}

const risk = {
    fxbzj: 'Tiền đặt cọc rủi ro',
    fxbz: 'Đảm bảo mọi giao dịch đều có sự bảo vệ an toàn tài chính toàn diện'
}

const license = {
    license: 'BiKing đạt được giấy phép tài chính MSB',
    hgyy: 'Hoạt động tuân thủ, phát triển toàn cầu',
    login: 'Đăng nhập',
    download: 'Quét mã để tải về BiKing',
    support: 'Hỗ trợ',
    jsjy: 'Giao dịch bất cứ lúc nào, thực hiện giao dịch siêu nhanh',
    ljxz: 'Tải ngay ứng dụng BiKing'
}

const footer = {
    yhyh: 'thân thiện với người dùng nhất',
    jypt: 'Sàn giao dịch hợp đồng',
    yhzc: 'Hỗ trợ người dùng',
    flsm: 'Mô tả tỷ lệ',
    ggzx: 'Trung tâm Thông báo',
    yhxz: 'Hướng dẫn cho người dùng',
    tksm: 'Điều khoản và Điều kiện',
    fxzs: 'Cảnh báo rủi ro',
    xylb: 'danh sách giao thức',
    gymw: 'Giới thiệu về chúng tôi',
    gy: 'Giới thiệu',
    lxwm: 'Liên hệ với chúng tôi',
    appxz: 'Tải xuống ứng dụng',
    callus: 'Đăng ký BIKING Genesis',
    zwzxxx: 'Luôn cập nhật những tin tức, thông tin chi tiết và biến động giá mới nhất',
    zc: 'Đăng ký',
    email: 'địa chỉ email',
    callingus: 'Liên hệ với chúng tôi',
    bqsy: 'Bản quyền',
    tips: 'Nhắc nhở nồng nhiệt: Đầu tư có rủi ro, vì vậy bạn cần thận trọng khi tham gia thị trường'
}

const card = {
    title: 'Tại sao chúng tôi là nền tảng hợp đồng thân thiện nhất',
    text: 'BiKing hỗ trợ bạn tạo ra, gia tăng và bảo quản tài sản',
    djxn: 'Hoàn trả phí giao dịch',
    jsqd: 'Hoàn trả phí giao dịch 100% ngay lập tức giảm chi phí đặt lệnh, tăng cơ hội lợi nhuận',
    zcbz: 'Rút/gửi tiền cực nhanh',
    cssbz: 'Rút/gửi tiền siêu nhanh, không giữ lại, đảm bảo an toàn vốn của người dùng mà không bỏ lỡ bất kỳ cơ hội nào',
    gld: 'Thuận tiện và dễ sử dụng',
    zxhd: 'Hoàn thành đăng ký & mở lệnh chỉ trong vòng 10 giây, hệ thống bảo mật riêng biệt bảo vệ quyền riêng tư của người dùng, quy trình đăng ký đơn giản hơn',
    qthfw: 'Dịch vụ toàn thời gian',
    kffw: 'Trải nghiệm tương tác mượt mà, cơ chế đảm bảo vàng 24/7 trực tuyến, giải đáp vấn đề giao dịch ngay lập tức',
    bjyy: 'Thuận tiện và dễ sử dụng',
    fxkk: 'Cung cấp nhiều hệ thống đơn hàng và công cụ giao dịch, quản lý rủi ro',
    axjy: 'Bất cứ nơi nào, bất cứ lúc nào · Giao dịch một cách an tâm',
    bkms: 'Nền tảng BiKing cung cấp phiên bản trang web, ứng dụng di động, API và kết nối FIX'
}

const news = {
    title: 'Tin tức & Tầm nhìn',
    text: 'Hiểu biết về tin tức và đặc điểm kinh doanh của sàn giao dịch tiền điện tử hàng đầu thế giới',
    sy: 'Tầm nhìn',
    ltitle: 'Bitcoin có thể giải quyết những thách thức đặc biệt của thị trường mới nổi',
    ldesc: 'Bài viết này ban đầu được xuất bản trên Cointelegraph. Khi Hội nghị Blockchain Economy Istanbul tập trung vào sự phát triển của thị trường mới nổi, sự phổ cập của Bitcoin tiếp tục được thúc đẩy bởi nhu cầu cụ thể?...',
    more: 'Tìm hiểu thêm',
    xwfbs1: 'Phòng báo chí',
    rdesc1: 'Sàn giao dịch tài sản số BiKing tài trợ Hội nghị Blockchain Economy Istanbul 2022',
    xwfbs2: 'Phòng báo chí',
    rdesc2: 'Sàn giao dịch tài sản số BiKing tài trợ Hội nghị Blockchain Economy Istanbul 2022'
}

const info = {
    hzhb: 'Đối tác của nền tảng giao dịch tự động',
    qsjy: 'Dễ dàng giao dịch trên BiKing với sự hỗ trợ của robot giao dịch',
    quadency: 'QUADENCY',
    clpt: 'Nền tảng chiến lược giao dịch tự động chuyên nghiệp',
    stacked: 'Stacked',
    glcf: 'Người dùng có thể sử dụng Stacked để đầu tư vào chỉ số tiền điện tử, thực hiện giao dịch tự động và quản lý tài sản'
}
const menu = {
  creditCardOrder: 'Thanh toán đơn hàng',
  ptmb: 'C2C',
  kjmb: 'Mua xu nhanh chóng',
  xykmb: 'Mua xu bằng thẻ tín dụng',
  order: 'Đặt hàng',
  userOrder: 'Đặt hàng của người dùng',
  merchantOrder: 'Đơn đặt hàng của người bán',
  quickOrder: 'Đặt hàng nhanh',
  merchant:'Thương gia',
  asMerchant:'Trở thành một thương gia',
  advertisingManage: 'Quản lý quảng cáo',
  financialStatements: 'Báo cáo tài chính',
  messageCenter: 'Trung tâm tin nhắn',
  more: 'Hơn',
  paymentSettings: 'Cài đặt thanh toán',
  publish: 'Đặt một quảng cáo',
  overview: 'Tổng quan',
  aqzx: 'Trung tâm bảo vệ',
  phsz: 'Sở thích',
  hykhj: 'Mùa lễ hội hợp đồng, kỷ nguyên giao dịch mới',
  xszn: 'Hướng dẫn cho người mới bắt đầu',
  bwyjy: 'Viện nghiên cứu BiKing',
  bwsq: 'Cộng đồng BiKing',
  yhxz: 'Thông tin người dùng',
  bwysp: 'Sản phẩm phái sinh của BiKing',
  jyxz: 'Hướng dẫn giao dịch OTC'
}
const otc = {
    Realtimequotes:'Báo giá theo thời gian thực chỉ mang tính chất tham khảo. Vui lòng tham khảo giá trên trang web của nhà cung cấp dịch vụ bên thứ ba để biết thêm thông tin.',
   Realtimequotes1:'Giới hạn giao dịch',
  Realtimequotes2:'Giá tham khảo  （{price}）',
  Realtimequotes3:'Mua hàng',
  Realtimequotes5:'Vui lòng nhập số tiền mua',
  Realtimequotes6:'Tối đa',
  Realtimequotes7:'Vượt quá giới hạn tối đa',
  Realtimequotes8:'Số lượng',
  Realtimequotes9:'Phí xử lý',
  Realtimequotes10:'Phương thức thanh toán',
  Realtimequotes11:'Thời gian giao hàng',
  Realtimequotes12:'10-20 phút sau khi thanh toán thành công',
  Realtimequotes13:'Xác nhận giao dịch',
  Realtimequotes14:'Các bước mua hàng',
  Realtimequotes15:'Chọn loại tiền kỹ thuật số bạn muốn mua, loại tiền pháp định bạn muốn thanh toán và nhà cung cấp dịch vụ bạn muốn sử dụng.',
  Realtimequotes16:'Nhập số tiền mua, điền thông tin của bạn trên trang web của nhà cung cấp dịch vụ bên thứ ba và hoàn tất thanh toán.',
  Realtimequotes17:'Xem loại tiền kỹ thuật số đã mua trong lịch sử nạp tài sản BiKing của bạn và xem chi tiết đơn hàng trên trang web của nhà cung cấp dịch vụ.',
  Realtimequotes18:'Bạn sẽ được chuyển hướng đến {XXXXX} để thực hiện giao dịch.',
  Realtimequotes24:'Lưu ý',
  Realtimequotes19:'{XXXXX} là một nền tảng giao dịch tiền pháp định và tiền điện tử của bên thứ ba hoạt động độc lập. Tất cả các dịch vụ liên quan đều do {XXXXX} cung cấp.',
  Realtimequotes20:'Giá tham khảo đã bao gồm phí nền tảng. Giá giao dịch thực tế dựa trên giá trên trang web chính thức của {XXXXX}.;',
  Realtimequotes21:'BiKing BiKing không chịu trách nhiệm cho bất kỳ tổn thất hoặc thiệt hại nào phát sinh do việc sử dụng dịch vụ này.',
  Realtimequotes22:'Rõ ràng, hãy tiếp tục ngay bây giờ.',
  Realtimequotes23:'số tiền mua',
  Realtimequotes25:'Giao dịch của bên thứ ba',
    Realtimequotes26:'Vui lòng điền địa chỉ email của bạn trước!',
      Realtimequotes27:'Hoàn thành ngay bây giờ.',
       Realtimequotes28:'Tên người bán bên thứ ba',
    meBuy: 'Tôi muốn mua',
      服务商: 'Nhà cung cấp dịch vụ',
    zxkdh: 'Tối thiểu có thể đổi {min} {symbol}',
    zdkdh: 'Tối đa có thể đổi {max} {symbol}',
    Available: 'Số dư khả dụng',
    Unknown: 'không xác định',
    qxgz: 'Chính sách hủy: Nếu người mua tích lũy hơn 200 lần hủy trong một ngày, chức năng mua hàng sẽ bị hạn chế cho ngày đó.',
    xncs: 'Bán cho bạn',
    qxzzffs: 'Vui lòng chọn phương thức thanh toán',
    qdqx: 'Xác nhận hủy bỏ',
    wzxx: 'Tôi cần suy nghĩ thêm',
    msk: 'Phương thức thanh toán của người mua',
    zhmc: 'Tên tài khoản',
    zhxq: 'Chi tiết tài khoản',
    xzhb: 'Chọn loại tiền tệ',
    
    buyer: 'Người mua',
    seller: 'Người bán',
    goSet: 'Điều chỉnh',
    addPayWayTitle: 'Thêm phương thức thanh toán',
    addPayWay: 'Bạn cần thêm hoặc kích hoạt ít nhất một phương thức thanh toán để có thể {type} tiền điện tử',
    supportPayWay: 'Bạn cần thêm và kích hoạt phương thức thanh toán hỗ trợ {type}',
    top: 'Trên cùng',
    marginTips: 'Bạn đã đặt cọc {baseMarginPaid} USDT, còn cần đặt cọc ít nhất {needMargin} USDT',
    eyqx: 'Mỗi ngày chỉ có thể hủy ba lần khiếu nại, nếu quá mức sẽ bị hạn chế khởi động khiếu nại. Đồng thời, nếu hủy một cách độc ác, tài khoản sẽ bị đóng băng, vui lòng thận trọng!',
    qdbzgm: 'Bạn có chắc không mua nữa không?',
    qxbtk: 'Sau khi hủy đơn hàng, không có hoàn trả, nếu bạn đã thanh toán, vui lòng không hủy đơn hàng.',
    yzjbzj: 'Người bán thông thường đã đặt thêm tiền đặt cọc',
    xbjjcbzj: 'Cần phải đóng thêm tiền đặt cọc cơ bản',
    jg: 'Giá',
    zxjgxd: 'Đặt lệnh với giá hiện tại',
    je: 'Số tiền',
    
    ccxe: 'Vượt quá giới hạn',
    yebz: 'Số dư không đủ',
    qxsm: 'Hãy xác minh danh tính trước',
    
    dfb: 'Chưa giải phóng tiền',
    jywc: 'Giao dịch hoàn tất',
    buy: 'Mua',
    sell: 'Bán',
    coin: 'Loại tiền',
    allCoin: 'Tất cả các loại tiền',
    frenchCurrency: 'Tiền pháp',
    payWay: 'Phương thức thanh toán',
    all: 'Tất cả',
    bankCard: 'Thẻ ngân hàng',
    zfb: 'Alipay',
    wx: 'WeChat',
    search: 'Tìm kiếm',
    merchant: 'Người bán (Số đơn hoàn thành trong 30 ngày/Tỉ lệ hoàn thành trong 30 ngày)',
    turnover: 'Doanh số giao dịch',
    completionRate: '% Tỉ lệ hoàn thành',
    quotaOrNumber: 'Số lượng/Giới hạn',
    number: 'Số lượng',
    quota: 'Giới hạn',
    price: 'Giá',
    paymentMethod: 'Phương thức thanh toán',
    trade: 'Giao dịch',
    handlingFee: '0 Phí giao dịch',
    buyUsdt: 'Mua USDT',
    sellBtc: 'Bán USDT',
    theRemainingAmount: 'Số lượng còn lại',
    userRealName: 'Tên người dùng thật',
    businessMessage: 'Lời nhắn của người bán',
    wantPay: 'Tôi muốn thanh toán',
    wantSell: 'Tôi muốn bán',
    receive: 'Tôi sẽ nhận được',
    password: 'Mật khẩu',
    pleaseEnterPassword: 'Vui lòng nhập mật khẩu',
    cancel: 'Hủy bỏ',
    buyUSDT: 'Mua USDT',
    sellUSDT: 'Bán USDT',
    Paymentchannel :'Kênh thanh toán (vui lòng tham khảo tỷ giá của nhà cung cấp dịch vụ.)',
    lumpSum: 'Tổng số tiền',
    agree: 'Nếu bạn đồng ý thực hiện giao dịch C2C với BiKing, điều này có nghĩa là bạn chấp nhận',
    mzsm: 'Tuyên bố miễn trách nhiệm pháp lý giao dịch C2C của BiKing',
    quit: 'Thoát',
    confirm: 'Xác nhận',
    orderDetail: 'Chi tiết đơn hàng',
    limitExceeded: 'Vượt quá giới hạn',
    quantityRemaining: 'Số lượng còn lại không đủ',

    cryptoTitle: 'Chỉ cần vài bước có thể mua USDT dễ dàng',
    cryptoSubTitle: 'Nền tảng giao dịch hợp đồng tài sản kỹ thuật số hàng đầu toàn cầu với sự an toàn hàng đầu',
    availableBalance: 'Số dư khả dụng',
    sellAll: 'Bán tất cả',
    fundsTransfer: 'Chuyển khoản quỹ',
    threeStep: 'Chỉ cần ba bước để mua tiền',
    advantage: 'Ưu điểm khi chọn mua bán tiền mã hóa trên BiKing',
    commonQuestion: 'Câu hỏi phổ biến',
    otc_title: 'Sử dụng C2C 0 phí giao dịch tiền điện tử',
    otc_title1: 'Thực hiện giao dịch không phí trên BiKing một cách an toàn và dễ dàng. Giao dịch USDT ngay bây giờ thông qua nhiều phương thức thanh toán như chuyển khoản ngân hàng, thẻ tín dụng, v.v.',
    commonQuestion1: 'Giao dịch tiền điện tử C2C là gì?',
    commonQuestion2: 'Chi phí giao dịch C2C là bao nhiêu?',
    commonQuestion3: 'Người bán trên BiKing C2C là gì?',
    commonQuestion4: 'Người bán trên BiKing C2C có lợi nhuận không?',
    commonQuestion5: 'Làm thế nào để tránh lừa đảo C2C?',
    commonQuestion1_desc: 'Giao dịch tiền điện tử C2C là giao dịch trực tiếp giữa các bên, bạn có thể trao đổi tiền điện tử trực tiếp với nhau mà không cần một trung gian như các sàn giao dịch tập trung.',
    commonQuestion2_desc: 'Chi phí giao dịch C2C có thể khác nhau đáng kể tùy thuộc vào nền tảng, tiền điện tử cụ thể và tình trạng tắc nghẽn mạng lưới trong quá trình giao dịch. Tuy nhiên, BiKing C2C không thu phí cho giao dịch tiền điện tử, không cần trung gian.',
    commonQuestion3_desc: 'Người bán trên BiKing C2C là các người dùng đã được xác minh, họ có thể đăng quảng cáo giao dịch trên nền tảng và thực hiện giao dịch với các người dùng khác.',
    commonQuestion4_desc: 'Khả năng sinh lợi của người bán trên BiKing C2C phụ thuộc vào nhiều yếu tố, bao gồm chiến lược giao dịch, tần suất giao dịch, chênh lệch giá mua bán và tình hình thị trường tổng thể.',
    commonQuestion5_desc: 'Để phòng tránh lừa đảo C2C, hãy xác minh danh tính của đối tác, sử dụng nền tảng an toàn, hạn chế chia sẻ thông tin cá nhân hoặc tài chính và sử dụng phương thức thanh toán có thể theo dõi được.',
    register: 'Đăng ký',
    registerByPhone: 'Đăng ký bằng email hoặc số điện thoại',
    authentication: 'Xác minh danh tính',
    authenticationId: 'Hoàn thành xác minh danh tính, chỉ cần giấy tờ tùy thân',
    buyCoins: 'Mua tiền',
    buyCoinsByCard: 'Mua tiền bằng thẻ tín dụng/thẻ ghi nợ hoặc chuyển khoản ngân hàng',
    fast: 'Nhanh chóng và thuận tiện',
    easyUse: 'Quy trình mua tiền đơn giản',
    fastPayment: 'Chỉ cần vài phút là có thể nhận được tiền nhanh chóng.',
    multiplePayment: 'Nhiều phương thức thanh toán',
    platformSupports: 'Nền tảng hỗ trợ nhiều phương thức thanh toán',
    flexibleConvenient: 'Đảm bảo sự linh hoạt và thuận tiện cho người dùng.',
    safeReliable: 'An toàn và đáng tin cậy',
    measure: 'Sử dụng nhiều biện pháp và công nghệ an ninh',
    informationSecurity: 'Bảo vệ an toàn vốn và thông tin người dùng.',
    questionTitle1: '1. Giới thiệu về sàn giao dịch BiKing',
    questionSubTitle1: 'BiKing là một sàn giao dịch tài sản kỹ thuật số hàng đầu toàn cầu có trụ sở tại Singapore, sở hữu giấy phép MSB tại Hoa Kỳ/Canada, cung cấp các dịch vụ như giao dịch, lưu trữ và quản lý nhiều loại tài sản kỹ thuật số.',
    questionTitle2: '2. BiKing cung cấp những sản phẩm nào?',
    questionSubTitle2: 'BiKing cung cấp một số sản phẩm như sau: Hợp đồng vĩnh viễn - Độ sâu ưu tiên, khớp lệnh trong mili giây; Giao dịch ngay - 0 phí, giao dịch nhanh chóng; Cộng đồng sao chép - Người giao dịch kinh nghiệm, chiến lược ổn định; Giao dịch nhận quà - Chế độ độc đáo, không ngừng phúc lợi; Ví web - Dịch vụ toàn diện phi tập trung.',
    questionTitle3: '3. Làm thế nào để đăng ký tài khoản trên BiKing?',
    questionSubTitle3: 'Bạn có thể đăng ký tài khoản trên trang web chính thức hoặc ứng dụng BiKing. Nhấp vào "Đăng ký", hoàn thành quy trình đăng ký để sử dụng sàn giao dịch BiKing cho đầu tư tài chính số.',
    questionTitle4: '4. Làm thế nào để mua tiền số qua BiKing?',
    questionSubTitle4: 'Dịch vụ mua tiền nhanh chóng của BiKing hỗ trợ nhiều phương thức thanh toán và nhiều loại tiền tệ, mang lại nhiều lựa chọn và tiện ích cho người dùng trên toàn thế giới. Người dùng từ bất kỳ quốc gia hoặc khu vực nào cũng có thể mua tiền số dễ dàng bằng tiền tệ địa phương.',
    questionTitle5: '5. Làm thế nào để thực hiện giao dịch tài sản kỹ thuật số?',
    questionSubTitle5: 'Bạn có thể chọn tài sản kỹ thuật số bạn muốn giao dịch trên BiKing, sau đó, khi vào trang giao dịch, chọn mua hoặc bán, nhập số lượng và giá, sau đó xác nhận để hoàn tất giao dịch. BiKing hỗ trợ nhiều loại giao dịch tài sản kỹ thuật số, bao gồm Bitcoin, Ethereum, Litecoin, Ripple và nhiều loại khác.',
    questionTitle6: '6. Làm thế nào BiKing đảm bảo an toàn tài sản của người dùng?',
    questionSubTitle6: 'BiKing sử dụng công nghệ mã hóa đa lớp để bảo vệ thông tin và tài sản người dùng, đồng thời sử dụng phương pháp lưu trữ tách biệt giữa ví nóng và ví lạnh để đảm bảo an toàn tài sản của người dùng.',
  
    orderType: 'Loại đơn',
    orderStatus: 'Trạng thái đơn hàng',
    to: 'đến',
    startTime: 'Ngày bắt đầu',
    endTime: 'Ngày kết thúc',
    orderNo: 'Số đơn hàng',
    status: 'Trạng thái',
    totalPrice: 'Tổng giá',
    numberOrFee: 'Số lượng giao dịch/Phí giao dịch',
    tradingPartners: 'Đối tác giao dịch',
    time: 'Thời gian',
    operate: 'Thao tác',
    details: 'Chi tiết',
    noPay: 'Chưa thanh toán',
    payed: 'Đã thanh toán',
    finish: 'Đã hoàn thành',
    canceled: 'Đã hủy',
    complaint: 'Đang khiếu nại',
    legalCurrency: 'Số tiền pháp lý',
    virtualCurrency: 'tiền kỹ thuật số',
    virtualCurrencyAddress: 'Địa chỉ thanh toán',
    paymenttype: 'Hình thức thanh toán',
    createTime: 'Thời gian tạo',
    success: 'Thành công',
    pending: 'Đang xử lý',
    awaiting: 'Đang chờ xác nhận',
    declined: 'Thất bại',
    deposittokens:'Lệnh bán đang chờ người dùng gửi token',
    makepayment:'Lệnh mua đang chờ người dùng thanh toán',
    verification:'Danh tính người dùng đang được xác minh',
    Transactioncancelled:'Giao dịch đã hủy',
    Transactionrejected:'Giao dịch đã từ chối',
    mjskfs: 'Phương thức thanh toán của người bán',
    mjfkfs: 'Phương thức thanh toán của người mua',
    toPay: 'Đi thanh toán',
    ddzdqx: 'Nếu bạn chưa chọn phương thức thanh toán trong {payTime}, đơn hàng sẽ tự động hủy',
    paying: 'Người bán đang thanh toán...',
    fkckh: 'Số tham chiếu thanh toán: ',
    dfwfkqx: 'Nếu người bán chưa thanh toán trong {payTime}, đơn hàng sẽ tự động hủy',
    ddqxwfck: 'Đơn hàng đã hủy, không thể xem thông tin thanh toán',
    ddqxckh: 'Đơn hàng đã hủy, số tham chiếu thanh toán:',
    ssz: 'Đang khiếu nại, vui lòng đợi, số tham chiếu thanh toán:',
    qxss: 'Hủy khiếu nại',
    xzfkfs: 'Phương thức thanh toán bạn đã chọn',
    ddywc: 'Đơn hàng đã hoàn thành',
    ss: 'Khiếu nại',
    wcfqss: '* Sau 1 phút từ khi hoàn thành đơn hàng, bạn mới có thể khởi động quá trình khiếu nại',
    bnfqss: '* Sau {time} giờ hoàn thành, bạn sẽ không thể khởi động quá trình khiếu nại nữa',
    zxkf: '* Sau khi mua OTC, bạn cần đợi thêm 1 ngày (T+1) để rút tiền. Nếu có bất kỳ câu hỏi nào, vui lòng liên hệ với dịch vụ khách hàng.',
    sjyjn: 'Người bán đã đặt cọc {deposit} {depositName}',
    wen1: '1. Khi nào tôi sẽ nhận được thanh toán?',
    da1: 'Sau khi người mua thanh toán xong, bạn sẽ nhận được thông báo.',
    wen2: '2. Nếu người mua không thanh toán ngay sau khi đặt hàng, phải làm thế nào?',
    da2: 'Người bán không thể hủy đơn hàng, nhưng nếu thời gian chờ quá lâu, bạn có thể khởi động quá trình khiếu nại, đội ngũ dịch vụ khách hàng sẽ giúp bạn giải quyết vấn đề.',
    wen3: '3. Việc không giải phóng tài sản kỹ thuật số kịp thời sẽ ảnh hưởng như thế nào?',
    da3: 'Sau khi nhận được thanh toán, nếu bạn không xác nhận thanh toán kịp thời, có thể gây ra khiếu nại từ người mua, ảnh hưởng đến uy tín của bạn trên nền tảng; đồng thời, tài sản của bạn cũng sẽ bị đóng băng trong ví của bạn trên nền tảng cho đến khi xử lý xong.',
    wen4: '4. Lưu ý khi nhận thanh toán',
    da4: '1) Hãy xác nhận rằng bạn đã nhận được thanh toán từ người mua và đảm bảo rằng bạn không tin vào bất kỳ lý do nào để giải phóng tiền mã hóa. Hãy chắc chắn xác nhận thanh toán trước khi nhấp vào "Xác nhận thanh toán" để tránh mất tiền số! <br/>2) Khi tài khoản ngân hàng của người mua không trùng khớp với tên thật của tài khoản trên nền tảng, hãy chú ý đến rủi ro thanh toán. Nếu có bất kỳ thắc mắc nào, hãy khiếu nại kịp thời.',
    qzgdsjnzf: 'Chưa thanh toán, vui lòng thanh toán {totalAmounts} {fiatCurrency} cho {associatedAdMerchantNickname} trong vòng {payTime}, số tham chiếu thanh toán:',
    nxdfgm: 'Bạn đang mua {amount_s} {coinsName} từ {associatedAdMerchantNickname}（{realName}）',
    dfxngm: '{userNickName}（{realName}）đang mua {amount_s} {coinsName} từ bạn',
    nxdfcs: 'Bạn đang bán {amount_s} {coinsName} cho {associatedAdMerchantNickname}（{realName}）',
    dfxncs: '{userNickName}（${realName}）đang bán {amount_s} {coinsName} cho bạn',
    payed: 'Đã thanh toán',
    dddffx: 'Đang chờ người bán giải phóng...',
    njhdq: 'Bạn sẽ nhận được {quantity}{coinsName}',
    qxdd: 'Hủy đơn hàng',
    kfqss: 'Sau {complaintPayed} phút kể từ khi thanh toán, nếu người bán vẫn chưa giải phóng tiền, bạn có thể khởi động quá trình khiếu nại',
    yfkfkckh: 'Người bán đã thanh toán, số tham chiếu thanh toán:',
    qjkqrsk: 'Hãy xác nhận việc thanh toán ngay',
    ddnsk: 'Đang chờ bạn nhận thanh toán',
    zfje: 'Số tiền thanh toán',
    skzh: 'Số tài khoản nhận thanh toán:',
    fkzhxm: 'Tên tài khoản thanh toán:',
    qdskh: '* Hãy đảm bảo rằng bạn đã nhận được thanh toán cho đơn hàng hiện tại trong công cụ thanh toán của mình trước khi xác nhận',
    fbl: 'Gải phóng tiền',
    dfyqrfk: '* Người bán đã xác nhận thanh toán, nếu {complaintPayed} phút sau mà vẫn chưa nhận được thanh toán thực tế, bạn mới có thể khởi động quá trình khiếu nại',
    jkcssk: '* Sau 24 giờ kể từ khi người bán xác nhận thanh toán, bạn sẽ không thể khởi động quá trình khiếu nại nữa, hãy xác nhận thanh toán càng sớm càng tốt',
    qrfb: 'Xác nhận giải phóng tiền',
    qwbqr: 'Hãy đảm bảo xác nhận rằng bạn đã nhận được thanh toán cho đơn hàng hiện tại và xác nhận rằng số tiền là chính xác trước khi giải phóng tiền',
    wyqrskzq: 'Tôi xác nhận đã nhận thanh toán và số tiền là chính xác',
    tjssyy: 'Vui lòng nhập lý do khiếu nại',
    srssyy: 'Nhập lý do khiếu nại của bạn',
    sctpxt: 'Tải lên ảnh (không bắt buộc)',
    upload: 'Tải lên',
    zdscsz: '* Bạn có thể tải lên tối đa ba ảnh, hỗ trợ định dạng jpeg, jpg, png, hãy chắc chắn rằng kích thước nhỏ hơn 3Mb',
    sstj: 'Gửi đi',
    qrfk: 'Xác Nhận Thanh Toán',
    fkje: 'Số Tiền Thanh Toán',
    sdzz: '*Nền tảng không hỗ trợ tự động trừ tiền. Vui lòng chuyển số tiền vào tài khoản trên từ tài khoản của bạn. Sau khi chuyển khoản hoàn tất, vui lòng nhấn thanh toán. Nếu không nhấn nút thanh toán sau khi chuyển khoản, bất kỳ tổn thất nào phát sinh sẽ do bạn chịu.',
    bzts: '*Vui lòng không ghi thông tin như BTC, USDT hoặc BiKing trong phần ghi chú khi chuyển khoản, nếu không người bán có thể từ chối.',
    wfk: 'Chưa Thanh Toán',
    w: 'Tôi',
    srxxfs: 'Nhập thông tin, nhấn Enter để gửi',
    dan: 'đơn',
    bnch: 'Không thể thêm cùng loại phương thức thanh toán',
    sd:'Trao đổi',
    from:'Thanh toán',
    to:'Nhận được',
    rate:'Tỷ giá hối đoái',
    fees:'phí xử lý',
    slippage:'Trượt giá',
    standards:'Tiêu chuẩn thu phí xử lý',
    transactionamount:'{num} số tiền giao dịch',
    confirm:'Xác nhận trao đổi',
    records:'Tất cả hồ sơ',
    chaeckrecords:'Xem tất cả các bản ghi đổi thưởng flash》',
    tocurrency:'Đồng tiền tiêu dùng',
    consumption:'Số lượng tiêu thụ',
    Getcurrency:'Nhận tiền tệ',
    GetQuantity:'Nhận số lượng',
    ExchangeStatus:'Trạng thái quy đổi',
    Exchangetime:'Thời gian',
    Youwillconsume:'bạn sẽ tiêu thụ',
    YouwillGET:'bạn sẽ nhận được',
    Updatequote:'Cập nhật báo giá',
    Failed:'Thất bại',
    Consumption:'Kênh tiêu thụ',
    Completed:'Hoàn thành',
    successful:'Đổi thưởng thành công',
    Converted:'Bạn đã chuyển đổi thành công {aaa} sang {bbb}',
    recommend:'Gợi ý',
    wcsj: "Thời gian hoàn thành"
}
const otcMerchant = {
    bzj: 'Ký quỹ',
    mmggs: 'Số lượng quảng cáo mua và bán',
    bx: 'Không giới hạn',
    ggzed: 'Tổng hạn mức quảng cáo',
    kzjgged: 'Hạn mức quảng cáo bổ sung',
    zjbzjbs: 'Bội số ký quỹ bổ sung',
    tbzss: 'Hiển thị đồng bộ 10 mục',
    tjsjsqb: 'Gửi đơn đăng ký làm nhà cung cấp dịch vụ',
    wcgjkycrz: 'Hoàn tất xác thực KYC cấp cao',
    ynlx: 'Sau khi duyệt biểu mẫu, chuyên viên OTC sẽ liên hệ với bạn ngay lập tức',
    
    zbzl: 'Chuẩn bị tài liệu',
    kssh: 'Duyệt biểu mẫu nhanh chóng',
    
    h1: 'Giao dịch thông minh',
    h2: 'Trở thành chuyên gia giao dịch C2C',
    h3: 'Sắp trở thành nhà cung cấp dịch vụ được chứng nhận',
    sjqy: 'Quyền lợi của nhà cung cấp dịch vụ',
    c2cjy: 'Ngoài việc giao dịch C2C với <span>0% phí</span>, chúng tôi còn cung cấp nhiều quyền lợi phong phú cho nhà cung cấp dịch vụ',
    fbq: 'Khu vực thanh toán của bạn',
    ptsj: 'Nhà cung cấp dịch vụ thông thường',
    xsqy: 'Trở thành nhà cung cấp dịch vụ được chứng nhận, hưởng thêm nhiều quyền lợi',
    wtd: 'Sau khi đăng ký thành công, bạn có thể đăng một lệnh ủy thác',
    xjn: 'Cần đặt cọc {deposit}',
    ljsq: 'Đăng ký ngay',
    cwptsj: 'Bạn đã trở thành nhà cung cấp dịch vụ thông thường',
    cwrzsj: 'Bạn đã trở thành nhà cung cấp dịch vụ được chứng nhận',
    rzsj: 'Nhà cung cấp dịch vụ được chứng nhận',
    xrd: 'Được đánh giá cao nhất trên thị trường giao dịch',
    nbyq: 'Chỉ mời nội bộ Biking',
    rzbs: 'Nhận danh hiệu nhà cung cấp dịch vụ được chứng nhận cao cấp hơn',
    pmq: 'Có quyền ưu tiên xếp hạng',
    kffw: 'Nhận dịch vụ chăm sóc khách hàng 1-1',
    sjxy: 'Giao dịch theo Hợp đồng OTC {level}',
    xsjc: 'Hướng dẫn cho người mới',
    jygz: 'Quy tắc giao dịch',
    close: 'Đóng',
    submited: 'Tôi đã gửi',
    submitSuccess: 'Gửi thành công',

    sqsj: 'Đăng ký trở thành Người bán',
    fwxy: 'Thỏa thuận Dịch vụ Người bán trên Biking',
    xyb: 'Biking là một nền tảng dành riêng cho người dùng thực hiện giao dịch tài sản số và cung cấp các dịch vụ liên quan. Vì sự thuận tiện trong diễn đạt thỏa thuận này, trong thỏa thuận này, Công ty và trang web được gọi chung là "chúng tôi" hoặc bằng cách nói ngôi thứ nhất khác. Chỉ cần đăng ký và đăng nhập trang web này, bất kỳ cá nhân tự nhiên hoặc thực thể khác đều là người dùng của trang web này, cho thuận tiện trong diễn đạt thỏa thuận này, dưới đây sử dụng "bạn" hoặc ngôi thứ hai khác. Đối với sự thuận tiện trong diễn đạt thỏa thuận này, chúng tôi và bạn được gọi chung là "Hai bên", chúng tôi hoặc bạn được gọi là "Một bên".',
    ptsm: 'Tuyên bố của Nền tảng:',
    p1: '1. Trang web này chỉ hoạt động như một nơi cung cấp thông tin giao dịch tài sản số, đàm phán và giao dịch về tài sản số, trang web này không tham gia vào bất kỳ giao dịch tài sản số cụ thể nào, do đó cả hai bên giao dịch đều phải tự cẩn thận xác định tính chân thực, hợp pháp và hiệu quả của tài sản số và / hoặc thông tin liên quan và tự chịu trách nhiệm và tổn thất phát sinh từ đó.',
    p2: '2. Mọi ý kiến, tin tức, thảo luận, phân tích, giá cả, đề xuất và thông tin khác trên trang web này chỉ là bình luận thị trường chung và không tạo thành lời khuyên đầu tư. Chúng tôi không chịu trách nhiệm về mọi tổn thất phát sinh trực tiếp hoặc gián tiếp do phụ thuộc vào thông tin đó, bao gồm nhưng không giới hạn trong bất kỳ tổn thất lợi nhuận nào.',
    p3: '3. Nội dung trang web này có thể thay đổi bất kỳ lúc nào mà không cần thông báo trước, chúng tôi đã thực hiện các biện pháp hợp lý để đảm bảo tính chính xác của thông tin trên trang web, nhưng không thể đảm bảo mức độ chính xác của nó và sẽ không chịu trách nhiệm về mọi tổn thất phát sinh trực tiếp hoặc gián tiếp từ thông tin trên trang web này hoặc từ sự chậm trễ hoặc thất bại trong việc liên kết Internet, truyền tải hoặc nhận thông báo và thông tin nào đó.',
    p4: '4. Hệ thống giao dịch qua Internet cũng mang theo rủi ro, bao gồm nhưng không giới hạn trong việc lỗi phần mềm, phần cứng và liên kết Internet. Vì chúng tôi không thể kiểm soát độ tin cậy và khả dụng của Internet, chúng tôi sẽ không chịu trách nhiệm về mọi tổn thất phát sinh từ sự méo mó, chậm trễ và thất bại liên kết.',
    p5: '5. Cấm sử dụng trang web này để thực hiện mọi hoạt động giao dịch phi pháp như rửa tiền, buôn lậu, hối lộ thương mại, v.v. Nếu phát hiện bất kỳ hoạt động giao dịch hoặc hành vi vi phạm pháp luật nào, trang web này sẽ thực hiện mọi biện pháp có thể, bao gồm nhưng không giới hạn việc đóng tài khoản, thông báo cho các cơ quan quyền lực liên quan, chúng tôi không chịu trách nhiệm về mọi tổn thất phát sinh từ đó và giữ quyền theo đuổi trách nhiệm của các bên liên quan.',
    p6: '6. Cấm sử dụng trang web này để thực hiện mọi hoạt động giao dịch phi đạo đức như thao túng thị trường, giao dịch không đạo đức, v.v. Nếu phát hiện sự việc như vậy, trang web này sẽ thực hiện biện pháp bảo vệ dự phòng như cảnh báo, hạn chế giao dịch, đóng tài khoản, v.v., chúng tôi không chịu trách nhiệm về mọi tổn thất phát sinh từ đó và giữ quyền theo đuổi trách nhiệm của các bên liên quan.',
    p7: 'Khi bạn đồng ý với Thỏa thuận Dịch vụ Người bán của Biking, có nghĩa là bạn đã đồng ý với toàn bộ nội dung của Tuyên bố Nền tảng này. Thỏa thuận này được ký kết chung bởi bạn và người điều hành Biking, thỏa thuận này có hiệu lực hợp đồng đầy đủ.',
    zcbzj: 'Điều 1: Tiền đặt cọc tài sản',
    p8: '1. Sau khi Người bán đã được phê duyệt KYC và kiểm tra chống rửa tiền bởi Nền tảng, Nền tảng này sẽ yêu cầu Người bán gửi một khoản tiền đặt cọc nhất định vào tài khoản trên nền tảng để đảm bảo an toàn và mượt mà của giao dịch của họ trên nền tảng.',
    p9: '2. Số tiền cụ thể của khoản đặt cọc sẽ được hiển thị trong tài sản phi tài sản của Người bán trên nền tảng và cũng sẽ được hiển thị cho người dùng trong quá trình giao dịch.',
    p10: '3. Khi xuất hiện các trường hợp sau, Nền tảng này có quyền thực hiện các biện pháp như giữ lại tiền đặt cọc của Người bán, tiền đặt cọc có thể bị giữ lại ≥1 tháng, xác định làm tổn thất cho Nền tảng và người dùng, sau đó sẽ được giảm trừ tiền đặt cọc theo tỷ lệ.',
    p11: '1) Trong quá trình giao dịch, Người bán gặp tranh chấp và Người bán được xác định phải chịu trách nhiệm và thực hiện các nghĩa vụ tương ứng, nhưng Người bán không hợp tác;',
    p12: '2) Người bán giao dịch với tài khoản trên nền tảng chưa được xác minh danh tính;',
    p13: '3) Người bán sử dụng nền tảng này để thực hiện bất kỳ hành vi bất hợp pháp nào;',
    p14: '4) Người bán vi phạm thỏa thuận này hoặc các quy định tài liệu pháp luật hoặc quy tắc giao dịch trên trang web;',
    p15: '5) Người bán có dấu hiệu đưa người dùng đến các nền tảng khác giao dịch;',
    p16: '6) Người bán có dấu hiệu hướng dẫn người dùng đăng ký giả mạo, lừa đảo để nhận phần thưởng quảng bá người dùng mới của nền tảng;',
    p17: '7) Người bán có dấu hiệu khuyến khích người dùng của đối tác cộng tác của nền tảng chuyển đến các nền tảng khác.',
    cxzg: 'Điều 2: Hủy bỏ tư cách Người bán',
    p18: 'Nếu xuất hiện các tình huống sau đây, Nền tảng này có quyền chấm dứt một cách độc lập tư cách Người bán của bạn:',
    p19: '1. Trong quá trình giao dịch, nhiều lần bị người dùng trên nền tảng này khiếu nại;',
    p20: '2. Trong tài liệu đăng ký, có thông tin giả mạo nào đó;',
    p21: '3. Xuất hiện hành vi lừa dối như gian lận trong giao dịch;',
    p22: '4. Không hợp tác với dịch vụ khách hàng của nền tảng xử lý đơn hàng hoặc trì hoãn ý định chế độ đơn hàng một cách cố ý;',
    p23: '5. Lợi dụng quy tắc của nền tảng để kiếm lời;',
    p24: '6. Vi phạm pháp luật, thỏa thuận này hoặc quy định của tài liệu pháp luật hoặc quy tắc giao dịch trên trang web;',
    p25: '7. Tồn tại hành vi được nền tảng đánh giá không phù hợp với đạo đức, công bằng giao dịch;',
    p26: '8. Hành vi vi phạm pháp luật nào khác.',
    zlbh: 'Điều 3: Bảo vệ thông tin Người bán',
    p27: '1. Quản lý thông tin Người bán: Thông tin xác minh (bao gồm cả tài liệu xác minh danh tính trước đây) mà bạn gửi cho trang web này khi đăng ký để trở thành Người bán sẽ được trang web này giữ lại một cách không thể rút lại. Trang web này cam kết rằng ngoại trừ lý do pháp lý hoặc thỏa thuận, nó sẽ không công khai, biên tập hoặc tiết lộ thông tin xác minh của bạn và sẽ không sử dụng nội dung không công khai lưu trữ trên trang web này cho mục đích thương mại, ngoại trừ các trường hợp sau: Bạn đã ủy quyền trang web này để tiết lộ thông tin liên quan;',
    p28: '2. This website provides information to national judicial and administrative authorities;',
    p29: '3. This website provides information to affiliated enterprises of this website;',
    p30: '4. When a third party and this website provide services to users together, the third party provides the relevant information needed for the service to you;',
    p31: '5. Based on the need to resolve civil disputes between you and third parties, this website has the right to provide your identity information to the third party.',
    sjcn: 'Article 4: Merchant Commitment',
    p32: '1. Acceptance of all terms of this agreement is a prerequisite for your application for certification.',
    p33: '2. You declare and guarantee that you will not apply for certification for any illegal or prohibited purpose under this agreement.',
    p34: '3. You shall not use the application service in a manner that may damage, disable, overload, or impair the services of other websites or this website, or interfere with others\' use of the application for merchants.',
    p35: '4. You shall not obtain or attempt to obtain any materials or information in any way not authorized by this website.',
    p36: '5. You confirm and promise that your use of this website for transactions is not for the purpose of violating laws and regulations or disrupting the order of digital asset transactions on this website.',
    p37: '6. The merchant promises to comply with all information disclosure requirements for digital asset transactions on the platform, and provide documents, materials, or information truthfully as required by the platform. If the merchant refuses to provide the documents, materials, or information required by the platform, Party B has the right to decide to revoke the merchant\'s qualification depending on the situation.',
    ptmz: 'Article 5: Platform Disclaimer',
    bcfx: 'In the following cases, the platform assumes no responsibility:',
    p38: '1. If you disclose your account password to others, fail to keep your password secure, or share your account with others, resulting in the leakage of your personal information;',
    p39: '2. Any impact caused by hacking, computer virus intrusion or attack, technical adjustments by the telecommunications department, temporary closure caused by government control, or the leakage, loss, theft, or tampering of certification information caused by reasons other than the fault of this website;',
    p40: '3. Any legal disputes and consequences caused by the disclosure of bank account information due to links with other websites (such as online banks) other than this platform;',
    p41: '4. Any loss caused by providing incorrect, incomplete, or false information to this website, etc., has nothing to do with this website;',
    p42: '5. Your assets are defrauded by others for reasons other than the fault of this platform.',
    ptts: 'Article 6: Platform Tips',
    p43: '1. To achieve identity verification, this website may include links to third-party websites (such as online banking websites). The "linked websites" are not controlled by this website, and this website is not responsible for the content of any "linked websites," including but not limited to any links contained in "linked websites" or any changes or updates to "linked websites." The transmission of network communication or other forms received by "linked websites" is not the responsibility of this website.',
    p44: '2. This platform only provides online trading platform services for you to conduct digital asset trading activities (including but not limited to digital asset trading services) through this website. This website does not act as a buyer or seller participating in the buying and selling of digital assets itself; this website does not provide any services related to the deposit and withdrawal of national legal currencies.',
    p45: '3. Once you log in to this website, use any services of this website, or any other similar behavior, it means that you have understood and fully agreed to all the contents of this agreement, including any modifications to this agreement made by this website at any time, without separately notifying you.',
    p46: '4. Your actions of clicking on any button marked with "Agree" or similar meaning or actually using the services provided by this website in any other way allowed by this website, mean that you fully understand, agree, and accept all the terms under this agreement, and without your handwritten written signature, this agreement has no legal binding effect on you.',
    p47: '5. We reserve the right to revise this agreement from time to time and announce it by posting it on the website. Your rights after the change will be effective immediately upon being published on the website.',
    tyxy: 'I agree to the content of this agreement',
    nextStep: 'Next'
}
const user = {
    "txxz": "Sau 24 giờ, không thể rút tiền khi bạn đã thay đổi mật khẩu tài khoản",
    "name": "Biệt danh",
    "rzdj": "Cấp độ xác minh danh tính",
    "phone": "Điện thoại",
    "email": "Email",
    "zzc": "Ước tính giá trị tài sản",
    "hours24": "24 giờ",
    "market": "Tình hình thị trường",
    "notice": "Thông báo",
    "more": "Xem thêm>>",
    "cb": "Nạp tiền",
    "tb": "Rút tiền",
    "hz": "Chuyển khoản",
    "wsm": "Chưa có thông tin xác minh danh tính",
    "cjrz": "Xác minh cấp độ sơ cấp",
    "gjrz": "Xác minh cấp độ cao cấp",
    qwgjrz: "Đi đến Xác thực Nâng cao",
    "aqszx": "Các mục đã thiết lập an toàn",
    "xgaqszx": "Thay đổi cài đặt an toàn của bạn",
    "dlmm": "Mật khẩu đăng nhập",
    "zjdl": "Bằng cách đặt mật khẩu đăng nhập, bạn có thể đăng nhập trực tiếp bằng tài khoản và mật khẩu đăng nhập",
    "ghmm": "Thay đổi mật khẩu",
    "sz": "Thiết lập",
    "jymm": "Mật khẩu giao dịch",
    "yzjymm": "Khi có biến động về tiền trong tài khoản, bạn cần xác nhận mật khẩu giao dịch trước.",
    "ghjymm": "Thay đổi mật khẩu giao dịch",
    "sjyz": "Xác nhận số điện thoại",
    "yzdx": "Sử dụng để đăng nhập, rút tiền, thay đổi mật khẩu, nhận tin nhắn xác nhận khi cài đặt an toàn",
    "xgsj": "Thay đổi số điện thoại",
    "zwbd": "Chưa kết nối",
    "ggyz": "Xác nhận Google",
    "syzn": "Hướng dẫn sử dụng",
    "bd": "Kết nối",
    "yxyz": "Xác nhận Email",
    "tbqr": "Bạn có thể kết nối một địa chỉ email thường dùng, được sử dụng để đăng nhập, khôi phục mật khẩu, và xác nhận khi rút tiền",
    "bdyx": "Kết nối Email",
    xgyx: "Sửa đổi email",
    xyx: "Email mới",
    "dljl": "10 bản ghi đăng nhập gần đây",
    "zjdljl": "Đây là 10 bản ghi đăng nhập gần đây của bạn",
    "dlsj": "Thời gian đăng nhập gần đây",
    "ip": "Địa chỉ IP",
    "aqsz": "Cài đặt an toàn",
    "yhdl": "Đăng nhập người dùng",
    "xgbdsj": "Thay đổi số điện thoại kết nối",
    "bdsj": "Kết nối số điện thoại",
    "dxyzm": "Mã xác nhận tin nhắn",
    "second": "Giây",
    "fsyzm": "Gửi mã xác nhận",
    "xsjh": "Số điện thoại mới",
    "ggyzm": "Mã xác nhận Google",
    "yxyzm": "Mã xác nhận Email",
    "confirm": "Xác nhận",
    "edit": "Thay đổi",
    "srxm": "Nhập tên",
    "name": "Tên",
    "zjlx": "Loại giấy tờ",
    "xzzjlx": "Chọn loại giấy tờ",
    "zjhm": "Số giấy tờ",
    "srzjhm": "Nhập số giấy tờ",
    "zcsr": "Nhập mật khẩu lần nữa",
    "mmbyz": "Mật khẩu nhập lại không khớp!",
    "sfz": "Chứng minh nhân dân",
    "jgz": "Chứng minh quân nhân",
    "hz": "Hộ chiếu",
    "jmtxz": "Thẻ thông hành dành cho cư dân của tỉnh Đài Loan",
    "gatxz": "Thẻ thông hành dành cho cư dân của Hồng Kông và Macau",
    "hwid": "ID Quốc tế",
    "srdx": "Nhập mã xác nhận tin nhắn",
    "sryx": "Nhập mã xác nhận Email",
    "srgg": "Nhập mã xác nhận Google",
    "jdlmm": "Mật khẩu đăng nhập cũ",
    "xdlmm": "Mật khẩu đăng nhập mới",
    "qrxmm": "Xác nhận mật khẩu mới",
    "qrdlmm": "Xác nhận mật khẩu đăng nhập",
    "jjymm": "Mật khẩu giao dịch cũ",
    "xjymm": "Mật khẩu giao dịch mới",
    "qrjymm": "Xác nhận mật khẩu giao dịch",
    "qwcyz": "Hãy hoàn thành xác nhận",
    "smrz": "Hãy xác minh danh tính trước",
    "sryzm": "Nhập mã xác nhận",
    "srsjh": "Nhập số điện thoại",
    "xgdlmm": "Thay đổi mật khẩu đăng nhập",
    "szdlmm": "Thiết lập mật khẩu đăng nhập",
    "xgjymm": "Thay đổi mật khẩu giao dịch",
    "szjymm": "Thiết lập mật khẩu giao dịch",
    "czmm": "Đặt lại mật khẩu",
    
    bdgg: 'Bind Google Authenticator',
    lbyzq: 'Please download Google Authenticator',
    smewm: 'Use Google Authenticator to scan the QR code',
    srdm: 'If the QR code cannot be recognized, please manually enter the following code',
    copy: 'Copy',
    copySuccess: 'Copy successful',
    sryx: 'Enter email',
    srzqyx: 'Enter a valid email address',
    srsjyzm: 'Enter SMS verification code',
    sryxyzm: 'Enter email verification code',
    srggyzm: 'Enter Google verification code',
    passwordTypeError: 'Password format error. Password must be 8-32 characters long and include both uppercase and lowercase letters and numbers.',
    passwordDiff: 'Passwords entered twice do not match',
    zcsrxmm: 'Enter password again',
    language: 'Language',
    bdhb: 'Local currency',
    wdbph: 'Stablecoin preference',
    "相关问题": "Câu hỏi Liên quan",
    "为什要进行身份认证": "Tại sao cần xác minh danh tính",
    "上传中": "Đang tải lên...",
    "开始上传": "Bắt đầu Tải lên",
    "请手持身份证正面": "Vui lòng cầm chính diện thẻ căn cước dưới khuôn mặt",
    "正对摄像头": "Đối diện camera, giữ trong ít nhất 5 giây",
    "摘下眼镜": "Tháo kính, nón hoặc các vật che mắt khác",
    "请按视频文字提示录制视频": "Vui lòng tuân thủ theo hướng dẫn trên màn hình để ghi video",
    "开始录制": "Bắt đầu Ghi",
    "第一段视频": "Đoạn video thứ nhất",
    "第二段视频": "Đoạn video thứ hai",
    "录制一段视频": "Ghi một đoạn video",
    "点击开始录制": "Nhấn để bắt đầu ghi",
    "视频录像认证": "Xác minh qua Video",
    "身份证号": "Số chứng minh nhân dân",
    证件验证: "Xác thực giấy tờ (Ảnh chụp/Bản scan)",
    zjyz: "Xác thực giấy tờ",
    "请确保图片格式为": "Vui lòng đảm bảo định dạng ảnh là jpg/jpeg/png. Đảm bảo kích thước ảnh nhỏ hơn 2MB",
    "请手持证件照": "Vui lòng cầm ảnh chứng minh nhân dân và chữ ký cá nhân. Chữ ký cần bao gồm 'Biking' và ngày hiện tại",
    "当日签名照": "Ảnh chứng minh nhân dân + chữ ký ngày",
    "上传证件签名页": "Tải lên trang chứng minh nhân dân có chữ ký",
    "请保证所有信息清晰": "Vui lòng đảm bảo tất cả thông tin rõ ràng",
    "上传证件页信息": "Tải lên trang thông tin chứng minh nhân dân",
    "请选择国家": "Chọn Quốc gia",
    "请选择区域": "Chọn Khu vực",
    "认证要求": "Yêu cầu Xác minh",
    "证件信息": "Thông tin Chứng minh nhân dân",
    "人脸识别": "Nhận diện khuôn mặt",
    "立即认证": "Xác minh Ngay",
    "什么是加密货币P2P交易": "P2P giao dịch tiền điện tử là gì",
    "最好的P2P加密货币交易所是什么": "Sàn giao dịch tiền điện tử P2P tốt nhất là gì",
    "P2P交易的成本有多少": "Chi phí giao dịch P2P là bao nhiêu",
    "什么是BikingP2P上的商家": "Những người bán trên Biking P2P là gì",
    "我们正在审核您的申请": "Chúng tôi đang xem xét đơn của bạn",
    "预计审核时间": "Dự kiến thời gian xem xét: 72 giờ",
    "驳回": "Từ chối",
    "未提交": "Chưa Gửi",
    "手续费等级": "Cấp độ Phí",
    "去认证": "Đi đến Xác minh",
    "开通更多权限": "Xác minh danh tính để mở khóa nhiều quyền hạn hơn",
    "在别人贪婪时要保持警惕": "Hãy cảnh báo khi người khác tham lam, và hãy tham lam khi người khác cảnh báo",
    kyc声明: 'Tôi là {Name}, và số căn cước/CMND của tôi là: {No}. Tôi tự nguyện đăng ký và thực hiện giao dịch trên Biking, đảm bảo rằng tài khoản được sử dụng bởi chính tôi. Tôi cam kết rằng tất cả tài sản đều có nguồn gốc hợp pháp, và tôi hiểu và có thể chịu đựng mọi rủi ro giao dịch. Các tài sản số được rút ra sẽ không được sử dụng cho mục đích bất hợp pháp, và tôi sẽ không tham gia bất kỳ hoạt động bất hợp pháp nào trên nền tảng này, như rửa tiền, mô hình Pirâmide và hoán đổi tiền tệ bất hợp pháp.',
    编辑头像: "Chỉnh sửa ảnh đại diện",
    请选择一个头像用作您个人资料的照片: "Vui lòng chọn một ảnh để sử dụng làm ảnh đại diện cá nhân của bạn",
    中国: "Trung Quốc",
    其他: "Khác",
    questionTitle1: '1. Tại sao cần cung cấp xác thực danh tính?',
    questionSubTitle1: 'CoinKing sử dụng dịch vụ xác thực danh tính toàn cầu tuân thủ quy định, đảm bảo an toàn vốn của tất cả người dùng. Vì vậy, khi điền thông tin, vui lòng cung cấp tài liệu phù hợp.',
    questionTitle2: '2. Có lợi ích gì khi hoàn thành xác thực danh tính?',
    questionSubTitle2: 'Tất cả người dùng phải hoàn thành xác thực danh tính để truy cập vào chức năng OTC của CoinKing. Người dùng chưa hoàn thành xác thực danh tính không ảnh hưởng đến việc nạp và rút tiền trên chuỗi.',
    questionTitle3: '3. Làm thế nào để cập nhật xác thực danh tính?',
    questionSubTitle3: 'Nếu thông tin danh tính của bạn thay đổi và đáp ứng các điều kiện sau, bạn có thể liên hệ với dịch vụ khách hàng trực tuyến để yêu cầu cập nhật xác thực danh tính:',
    questionTitle4: '4. Xác thực KYC mất bao lâu?',
    questionSubTitle4: 'Thông tin bạn gửi thường được xác minh trong vòng 5 phút. Tuy nhiên, trong các trường hợp đặc biệt, có thể cần nhiều thời gian hơn.',
    questionTitle5: '5. Xác thực danh tính của CoinKing có an toàn không?',
    questionSubTitle5: 'Xác thực danh tính của CoinKing là an toàn và giúp chúng tôi xây dựng một nền tảng an toàn cho bạn và tất cả người dùng khác. Tài liệu của bạn cũng được bảo mật bởi chúng tôi.',
    questionTitles:'1. Chứng minh thư hết hạn;',
    questionTitles1:'2. Tên trên chứng minh thư đã thay đổi;',
    questionTitles2:'3. Số CMND trên chứng minh thư đã thay đổi;',
    questionTitles3:'4. Quốc tịch đã thay đổi;',
    questionTitles4:'5. Cập nhật chứng minh để đảm bảo sử dụng tiền tệ pháp lý;',
    questionTitles5:'6. Thay đổi tên được nhận dạng bằng ngôn ngữ hệ thống (ví dụ: từ CMND quốc gia sang hộ chiếu);',
    Z1001: "Lỗi hệ thống",
    Z1003: "Xác thực bị gián đoạn",
    Z2002: "Lỗi mạng",
    Z2003: "Lỗi thời gian thiết bị của khách hàng",
    Z2006: "Xác thực thất bại",
    Z5050: "Xác thực khuôn mặt thành công",
    Z5051: "Không thể tải lên ảnh khuôn mặt",
    Z5052: "Dữ liệu hoặc ngoại lệ chương trình không chính xác",
    Z5053: "Lỗi mạng",
    Z5054: "Không có quyền truy cập máy ảnh hoặc không thể lấy dữ liệu từ máy ảnh",
    Z5055: "Người dùng thoát",
    Z5056: "Quá nhiều lần thử lại",
    Z5057: "Thời gian tải lên video đã hết",
    Z5058: "Định dạng video không đáp ứng yêu cầu",
    Z5059: "Không có khuôn mặt hợp lệ trong video",
    Z5128: "Xác thực không phải của cùng một người",
    法币充值:'Giới hạn nạp tiền và rút tiền tiền tệ',
    无限额:'Không giới hạn',
    数字货币充值:'Nạp tiền tiền điện tử',
    数字货币提现限额:'Giới hạn rút tiền tiền điện tử',
    C2C交易限额:'Giới hạn giao dịch C2C',
    "参数不合法": 'Tham số không hợp lệ',
    h5smrz: "Xác thực tên thật",
    bhzhan: "Đặt mật khẩu để bảo vệ tính bảo mật cho tài khoản của bạn",
    jxsmrz: "Thực hiện xác thực tên thật để đảm bảo an toàn cho tiền của người dùng",
    qwrz: "Đi đến Xác thực",
    dgzhzd: "1. Một tài khoản duy nhất có thể được gửi tối đa 5 lần mỗi ngày.",
    rhzp: "2. Bất kỳ ảnh, video hoặc chi tiết tài liệu nào bạn gửi sẽ không được lưu trữ hoặc sử dụng dưới bất kỳ hình thức nào.",
    sfzm: "Giấy tờ Tùy thân",
    zjqfg: "Quốc gia Cấp phát Tài liệu",
    dw: "Định vị",
    sfxx: "Thông tin Nhận dạng",
    dqdw: "Vị trí Hiện tại",
    gjdq: "Quốc gia/Khu vực"
}

const h5 = {
    "chart": "Biểu đồ",
    "mmp": "Bảng mua bán",
    "sscj": "Giao dịch thời gian thực",
    "wt": "Lệnh đặt",
    "lswt": "Lịch sử lệnh đặt",
    "zj": "Quỹ",
    "sj": "Giá thị trường",
    "ky": "Khả dụng",
    "zczh": "Tổng tài sản",
    "dj": "Bị đóng băng",
    "zwsj": "Không có dữ liệu",
    "zx": "Tự chọn",
    "buysell": "Mua/Bán"
}

const worldCup = {
  common: {
    cancel: 'Hủy bỏ',
    confirm: 'xác nhận',
    iKnow: 'tôi hiểu rồi',
    points: 'tích phân',
    day: 'bầu trời',
    hour: 'Giờ',
    minute: 'điểm',
    second: 'Thứ hai',
    noData: 'Không có dữ liệu',
    noMatch: 'Chưa có trận đấu',
    businessClosed: 'Dịch vụ đã đóng',
    loadFailed: 'Tải thất bại, vui lòng thử lại sau',
  },
  index: {
    liveFeed: 'động lực thời gian thực',
    heroTitle: 'Đặt cược vào World Cup',
    heroSplit: 'khắc lên',
    heroPrizePool: 'Nhóm giải thưởng',
    heroMillionPrizePool: 'Chia sẻ quỹ thưởng 1 triệu',
    heroSub: 'Ngoài ra còn có vé Tesla và World Cup đang chờ bạn.',
    heroJoinedPrefix: 'Đã',
    heroJoinedSuffix: 'Mọi người đang tham gia và tổng giải thưởng tiếp tục tăng lên.',
    activityTimeLabel: 'Thời gian hoạt động:',
    refreshing: 'Đang làm mới...',
    releaseToRefresh: 'Thả ra để làm mới ngay lập tức',
    pullToRefresh: 'Kéo xuống để làm mới',
    livePrizePool: 'Nhóm giải thưởng thời gian thực',
    growing: 'Phát triển theo thời gian thực',
    userPoolRatioLabel: 'Người dùng cá nhân có thể chia sẻ tổng giải thưởng:',
    teamPoolRatioLabel: 'Các đội có thể chia sẻ tổng giải thưởng:',
    poolCountdownLabel: 'Đếm ngược đến thời điểm chia quỹ thưởng giai đoạn {phase}',
    poolCountdownFinalLabel: 'Đếm ngược đến khi chia quỹ thưởng giai đoạn cuối',
    poolActivityStartCountdownLabel: 'Đếm ngược đến khi sự kiện bắt đầu',
    poolSplitDoneBadge: 'Đã hoàn tất chia quỹ',
    totalAllocatedPoolLabel: 'Tổng quỹ đã chia',
    poolAllocateFirst: 'Đợt chia 1',
    poolAllocateSecond: 'Đợt chia 2',
    poolAllocateThird: 'Đợt chia 3',
    poolAllocateFinal: 'Chia cuối cùng',
    poolTeamPrefix: 'Đội: ',
    poolPersonalPrefix: 'Cá nhân: ',
    poolPersonalCount: 'Cá nhân: {n} người',
    teamTitle: 'Thành lập một nhóm và nhân đôi thu nhập của bạn',
    teamSubPrefix: 'Tham gia nhóm và có cơ hội thăng tiến',
    teamSubSuffix: 'thu nhập',
    teamAgentTitle: 'Đội ngũ đại lý',
    teamAgentDesc: 'Nhân viên nền tảng có thể thành lập nhóm chỉ bằng một cú nhấp chuột và <span class="wc-hl"> điểm của thành viên nhóm sẽ được tổng hợp thành tổng số điểm của nhóm </span>. Đồng thời, việc hoàn thành nhiệm vụ nhóm có thể kiếm thêm <span class="wc-hl"> điểm nhóm </span>. Điểm của đội càng cao thì <span class="wc-hl"> cơ hội chia sẻ tổng giải thưởng </span> càng lớn.',
    createTeamNow: 'Thành lập một đội ngay bây giờ',
    applyAgentNow: 'Tôi không phải là đại lý, hãy đăng ký ngay bây giờ',
    teamUserTitle: 'đội tự do',
    teamUserDesc: 'Không cần phải trở thành đại lý, bạn có thể tham gia nhóm miễn phí, thành lập nhóm với những người dùng miễn phí khác, tham gia <span class="wc-hl2"> điểm nhóm</span> và nhận <span class="wc-hl2"> cơ hội chia sẻ quỹ giải thưởng</span>.',
    joinNow: 'Tham gia ngay bây giờ',
    championTitle: 'Dự đoán giải vô địch',
    championSub: 'Mỗi người dùng chỉ có thể dự đoán một lần và không thể thay đổi sau khi khóa. Nếu dự đoán đúng, bạn sẽ đủ điều kiện để chia sẻ tổng giải thưởng riêng lẻ.',
    championHintPrefix: 'Người dùng dự đoán đúng người chiến thắng sẽ nhận được tổng giải thưởng',
    championHintSuffix: 'trình độ để khắc lên',
    championPoolShare: 'trình độ để khắc lên',
    championWin: 'Chúc mừng bạn đã đoán được người chiến thắng',
    championLose: 'Xin lỗi, bạn đã đoán không chính xác',
    championWinSub: 'nhận được suất chia thưởng từ quỹ cá nhân.',
    championNoParticipation: 'Sự kiện đã kết thúc, bạn chưa tham gia dự đoán',
    confirmPredict: 'Xác nhận dự báo',
    predictCountdown: 'Dự đoán đếm ngược',
    predictEnded: 'Dự đoán đã kết thúc',
    notice1: 'Người dùng p***12 vừa hoàn tất đặt cược và giành được 500 điểm',
    notice2: 'Người dùng k***88 vừa đổi một chiếc Tesla',
    notice3: 'Người dùng a***23 vừa hoàn tất đặt cược và giành được 1200 điểm',
    notice4: 'Người dùng x***56 đã mời bạn bè để nhận 100 điểm',
    notice5: 'Người dùng m***07 vừa đổi 1 vé xem World Cup',
    tabPredict: 'Cá cược',
    tabTask: 'Nhiệm vụ',
    tabRank: 'xếp hạng',
    tabExchange: 'trao đổi',
    tabMine: 'của tôi',
    tabRules: 'luật lệ',
  },
  toast: {
    refreshSuccess: 'Làm mới thành công',
    predictSuccess: 'Cá cược đã thành công, kết quả đã được gửi',
    inviteJumping: 'Chuyển đến trang lời mời...',
    applyAgentPending: 'Chức năng ứng dụng đại lý đang được phát triển, vì vậy hãy chú ý theo dõi!',
    championLocked: 'Dự đoán vô địch đã bị khóa!',
    exchangeSubmitted: 'Đơn đăng ký đổi thưởng đã được gửi thành công và bộ phận dịch vụ khách hàng của nền tảng sẽ liên hệ với bạn để phân phối giải thưởng.',
    pointsNotEnough: 'Không đủ điểm',
    createTeamSubmitted: 'Tạo đội thành công',
    joinedFreeTeam: 'Gia nhập Đội Tự do',
  },
  section: {
    predictTitle: 'cá cược trận đấu',
    predictSub: 'Dự đoán kết quả trận đấu, +{correctPoints} điểm nếu đoán đúng, +{wrongPoints} điểm nếu đoán sai',
    predictRules: 'Hướng dẫn cá cược',
    taskTitle: 'Hoàn thành nhiệm vụ để kiếm điểm',
    taskSub: 'Nhiều nhiệm vụ, nhiều phần thưởng, tích lũy lợi nhuận nhanh chóng',
    exchangeTitle: 'Trung tâm đổi điểm',
    exchangeSub: 'Giải thưởng phong phú, đến trước được phục vụ trước',
    exchangeRules: 'Hướng dẫn đổi thưởng',
    rankTitle: 'Bảng xếp hạng thời gian thực',
    rankSub: 'Thi đấu bằng sức mạnh và đạt vị trí đầu bảng',
    rulesTitle: 'Quy tắc hoạt động',
    rulesSub: 'Minh bạch, công khai, công bằng và chính đáng',
  },
  dialog: {
    taskTitle: 'Tuyên bố sứ mệnh',
    taskReward: 'Có sẵn sau khi hoàn thành',
    predictConfirmTitle: 'cá cược trận đấu',
    predictConfirmHint: 'Bạn đoán đội nào sẽ thắng?',
    predictPay: 'chi trả',
    predictPayTip: 'Khấu trừ từ tài khoản vốn, vui lòng đảm bảo số dư đủ',
    predictConfirmBtn: 'Xác nhận đặt cược',
    predictSuccessTitle: 'Vụ cá cược đã thành công',
    predictSuccessDesc: 'Kết quả cá cược đã được gửi thành công và hồ sơ có thể được xem trong "Cá cược của tôi".',
    exchangeTitle: 'Trao đổi sản phẩm',
    exchangeNeedPoints: 'Điểm yêu cầu',
    exchangeBalance: 'Sự cân bằng:',
    exchangeContactTitle: 'Điền ít nhất một thông tin liên hệ',
    exchangeTipTitle: 'Lời khuyên tử tế',
    exchangeTip1: 'Vui lòng điền ít nhất một thông tin liên hệ. Sau khi gửi, bộ phận dịch vụ khách hàng của nền tảng sẽ liên hệ với bạn để thông báo về việc phân phối giải thưởng.',
    exchangeTip2: 'Nếu bạn không liên lạc trong một thời gian dài, vui lòng liên hệ với bộ phận chăm sóc khách hàng để xử lý.',
    exchangeConfirm: 'Xác nhận trao đổi',
    teamJoinTitle: 'Tham gia vào đội',
    teamCreateDesc: 'Bạn có chắc chắn sẽ thành lập một đội không?',
    teamJoinFreeDesc: 'Bạn có chắc chắn tham gia Freedom Team không?',
    teamJoinTipTitle: 'Lời khuyên tử tế',
    teamJoinTipDesc: 'Bạn là thành viên nhóm đại lý và không thể tham gia nhóm miễn phí. Bạn có thể mời người mời (đại lý) của mình thành lập một đội để tham gia vào các trận chiến đồng đội.',
    applyAgentContactTitle: 'Thông báo quan trọng',
    applyAgentContactPrefix: 'Vui lòng thêm Telegram: ',
    applyAgentContactSuffix: ' để đăng ký làm đại lý. Sau khi trở thành đại lý, bạn có thể tạo đội.',
    applyAgentContactBtn: 'Đã hiểu',
  },
  rank: {
    teamRank: 'Xếp hạng đội',
    personRank: 'Xếp hạng cá nhân',
    yourTeamRank: 'Thứ hạng của đội bạn',
    yourPersonRank: 'xếp hạng cá nhân của bạn',
    captain: 'trưởng nhóm:',
    currentPoints: 'Điểm hiện tại',
    members: 'thành viên',
    teamDetail: 'Chi tiết đội',
    noRankYet: 'Chưa có bảng xếp hạng',
  },
  mine: {
    myPoints: 'điểm của tôi',
    totalPoints: 'tổng điểm',
    myPredict: 'Đặt cược của tôi',
    myExchange: 'Trao đổi của tôi',
    myBonus: 'Thưởng của tôi',
    totalBonus: 'Tổng thưởng tôi nhận được',
    bonusPhase: 'Giai đoạn chia thưởng：',
    bonusPhaseFirst: 'Giai đoạn 1',
    bonusPhaseSecond: 'Giai đoạn 2',
    bonusPhaseThird: 'Giai đoạn 3',
    bonusPhaseFinal: 'Giai đoạn cuối',
    bonusTypeTeam: 'Chia theo đội',
    bonusTypePersonal: 'Chia cá nhân',
    bonusPoints: 'Điểm khi chia thưởng：',
    bonusType: 'Loại：',
    bonusAmount: 'Thưởng：',
    totalCount: 'Tổng {total} mục',
    myTeam: 'đội của tôi',
    selectTeam: 'Chọn một đội',
    predictMatch: 'Trận đấu',
    winTeam: 'đội chiến thắng',
    predictResult: 'Kết quả cá cược',
    hit: 'Đoán đúng',
    miss: 'Không đoán được',
    draw: 'Hòa',
    exchangeItem: 'Trao đổi vật phẩm',
    contactInfo: 'Thông tin liên hệ',
    exchangeStatus: 'Trạng thái quy đổi',
    currentRank: 'Xếp hạng hiện tại',
    notJoinedTeam: 'Chưa tham gia đội',
    memberContribution: 'Đóng góp của thành viên',
    teamTaskContribution: 'Đóng góp nhiệm vụ nhóm',
    loading: 'đang tải...',
    statusDone: 'Hoàn thành',
    statusPending: 'Xử lý',
    statusFail: 'Đổi thưởng không thành công',
    logCompleteKyc: 'Hoàn tất KYC',
    logExchangePrize: 'Đổi thưởng',
    logMatchPredict: 'cá cược trận đấu',
    logDailySign: 'Nhận phòng hàng ngày',
    logFinishTask: 'Hoàn thành nhiệm vụ',
    taskFirstRecharge: 'Hoàn tất khoản tiền gửi đầu tiên >= {amount} USDT',
    pagerTotal: 'Tổng số {total} mục',
    prevPage: 'Trang trước',
    nextPage: 'Trang tiếp theo',
    goTo: 'đi đến',
    page: 'Trang',
  },
  mobile: {
    title: 'Cá cược World Cup',
  },
  nav: {
    entry: 'Cá cược World Cup',
  },
  mock: {
    korea: 'Hàn Quốc',
    germany: 'nước Đức',
    china: 'Trung Quốc',
    uk: 'Vương quốc Anh',
    france: 'Pháp',
    portugal: 'Bồ Đào Nha',
    senegal: 'Sénégal',
    brazil: 'Brazil',
    india: 'Ấn Độ',
    turkiye: 'Thổ Nhĩ Kỳ',
    usa: 'Hoa Kỳ',
    jerseyPack: 'Bộ áo thi đấu chính thức',
    vipCard: 'Thẻ thành viên mã hóa VIP',
    jerseyKeyword: 'áo đấu',
  },
  predict: {
    round: {
      group: 'vòng bảng',
      r32: 'vòng 32',
      r16: 'vòng 16',
      quarter: 'tứ kết',
      semi: 'bán kết',
      third: 'trận tranh hạng ba',
      final: 'trận chung kết',
    },
    status: {
      joined: 'Đã tham gia',
      open: 'Mở',
      ongoing: 'Trong trò chơi',
      ended: 'đã kết thúc',
    },
    btn: {
      joined: 'Đã đặt cược',
      open: '{betPaymentAmount}USDT Đặt cược ngay',
      ongoing: 'Trò chơi đang diễn ra',
      ended: 'Cược đã kết thúc',
    },
    joinedMatchPhase: {
      pending: 'Chưa bắt đầu',
      ongoing: 'Đang diễn ra',
      ended: 'Đã kết thúc',
    },
    joinedResult: {
      hit: 'Đoán đúng +{points}',
      missPrefix: 'Đoán sai',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: 'Nguồn vốn',
    poolSplit: 'Chia sẻ quỹ giải thưởng',
    teamIntro: 'Mô tả đội',
    poolRulesTitle: 'Mô tả quỹ giải thưởng',
    teamRulesTitle: 'Mô tả đội',
    predictRulesTitle: 'Hướng dẫn cá cược',
    exchangeRulesTitle: 'Hướng dẫn đổi thưởng',
  },
  rulesText: {
    poolDesc1: 'Phần thưởng ban đầu của sự kiện là {initialFunds} USDT. Trong thời gian hiệu lực của sự kiện, một phần tiền thưởng kinh doanh sẽ được đầu tư vào quỹ giải thưởng theo tỷ lệ để liên tục tăng tổng quỹ giải thưởng.',
    poolLine1: '{rechargePercentageToPool}% của mỗi số tiền nạp lại sẽ tự động được đưa vào quỹ giải thưởng;',
    poolLine2: '{contractFeePercentageToPool}% của mỗi phí giao dịch hợp đồng vĩnh cửu sẽ tự động được đưa vào tổng giải thưởng;',
    poolLine3: 'Mỗi khi người dùng hợp lệ được mời, tổng giải thưởng sẽ tự động tăng thêm {additionalAmountPerValidUser} USDT.',
    poolLine4: '*Số tiền dưới 0,01 USDT sẽ không được tính vào quỹ giải thưởng.',
    teamPoolTitle: 'Prêmio de compartilhamento de equipe',
    teamPoolRuleTitle: 'Regras do prêmio para compartilhamento de equipe',
    teamPoolRule1: 'Após a determinação das 8 melhores equipes, a equipe classificada em primeiro lugar em pontos dividirá 20% do prêmio total e o saldo continuará acumulando.',
    teamPoolRule2: 'Os membros da equipe com direito a compartilhar o prêmio recebem recompensas com base no peso das contribuições dos pontos individuais. Membro de prêmio = [(prêmio total * proporção de compartilhamento da equipe) * (1 - 0.2) / soma dos pontos individuais dos membros com direito a compartilhar] * pontos individuais totais',
    userPoolTitle: 'Regras para usuários individuais compartilharem o prêmio',
    poolSplit1: 'Primeira divisão: após a determinação das 8 melhores equipes, a equipe classificada em primeiro lugar em pontos dividirá {percentage}% do prêmio e o saldo continuará acumulando.',
    poolSplit2: 'Segunda divisão: após a determinação das 4 melhores equipes, a equipe classificada em primeiro lugar em pontos dividirá {percentage}% do prêmio e o saldo continuará acumulando.',
    poolSplit3: 'Terceira divisão: após a finalização das semifinais, a equipe classificada em primeiro lugar em pontos dividirá {percentage}% do prêmio e o saldo continuará acumulando.',
    poolSplit4: 'Phân chia cuối cùng: sau khi trận chung kết kết thúc, đội xếp hạng nhất theo điểm sẽ chia {percentage}% tổng quỹ thưởng. Sau khi chia xong, điểm khả dụng của các thành viên đội sẽ được đặt về 0.',
    userPoolLine1: 'Khi kết thúc trò chơi, người dùng đoán đúng chức vô địch sẽ có quyền chia sẻ tổng giải thưởng riêng lẻ.',
    userPoolLine2: 'Tất cả người dùng đoán đúng đội vô địch sẽ chia {percentage}% quỹ thưởng dựa trên tổng điểm cá nhân. Sau khi chia xong, điểm khả dụng cá nhân sẽ được đặt về 0.',
    poolFormula: '*Ví dụ: một đội có N người dùng đủ điều kiện chia thưởng, điểm của từng người lần lượt là N1, N2, N3...Nn, tổng quỹ thưởng tại thời điểm chia là A, tỷ lệ chia kỳ này là 20%, tỷ lệ thưởng đội trưởng là 20%, thì tiền thưởng thành viên đội = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*tổng điểm cá nhân',
    teamRule1: '1. Chỉ các đại lý cấp một mới có thể bắt đầu thành lập nhóm. Nếu bạn không phải là đại lý, bạn có thể đăng ký để trở thành đại lý và thành lập một nhóm.',
    teamRule2: '2. Nếu bạn không phải là đại lý cũng như không thể đạt được bằng cấp đại lý, bạn có thể tham gia nhóm miễn phí do nền tảng đặt ra (người dùng không phải là đại lý)',
    teamRule3: '3. Sau khi một đại lý thành lập một đội, anh ta và các thành viên trong nhóm của mình sẽ tự động trở thành một đội.',
    teamRule4: '4.Tổng điểm nhóm = tổng điểm thành viên nhóm + điểm thưởng nhiệm vụ nhóm',
    teamRule5: '5. Yêu cầu về tiêu chuẩn để các thành viên trong nhóm chia sẻ quỹ giải thưởng: tham gia đoán ≥ {quizTimesThreshold} lần trong sự kiện + khối lượng giao dịch hợp đồng vĩnh cửu ≥ {poolContractThreshold}U',
    predictRule1: '1. Việc cá cược sẽ đóng sau khi cuộc thi bắt đầu',
    predictRule2: '2. Mỗi người dùng chỉ có thể tham gia đoán một lần cho mỗi trò chơi.',
    predictRule3: '3. Bạn cần trả {betPaymentAmount} USDT để đặt cược',
    predictRule4: '4. Đoán đúng đội thắng +{correctBonusPoints} điểm, đoán sai +{wrongBonusPoints} điểm',
    predictRule5: '5. Nếu trận đấu (vòng bảng) hòa, điểm sẽ được tính dựa trên việc đoán sai, +{wrongBonusPoints} điểm',
    exchangeRule1: '1. Số lượng giải thưởng có hạn và sẽ được đổi khi còn hàng; ai đến trước được phục vụ trước.',
    exchangeRule2: '2. Sau khi đổi giải thưởng, số điểm tương ứng sẽ bị trừ và điểm của đội bạn cũng sẽ bị trừ tương ứng.',
    exchangeRule3: '3. Điền thông tin liên hệ của bạn khi đổi giải thưởng và nhân viên nền tảng sẽ liên hệ với bạn về các vấn đề phân phối giải thưởng tiếp theo',
    exchangeRule4: '4. Thông tin liên hệ điền không chính xác khi đổi thưởng có thể khiến việc đổi thưởng bị chặn. Vui lòng xác nhận và kiểm tra cẩn thận và tiếp tục chú ý đến tin tức.',
    exchangeRule5: '5. Nếu bạn không nhận được liên hệ từ nền tảng trong một thời gian dài, vui lòng liên hệ với bộ phận dịch vụ khách hàng của nền tảng để xử lý.',
    timeTitle: 'Thời gian hoạt động',
    activePeriodLabel: 'Thời gian hợp lệ của hoạt động:',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: 'Điểm chỉ được tính và kiểm đếm sau khi sự kiện bắt đầu và tổng giải thưởng bắt đầu tích lũy.',
    predictPeriodLabel: 'Thời gian đặt cược:',
    predictPeriodValue: 'Cược Vô Địch: {startTime} ~ {endTime}',
    businessTitle: 'quy tắc kinh doanh',
    businessRule1: '1. Người dùng lời mời hợp lệ: Lời mời hợp lệ có nghĩa là số tiền nạp của người được mời là ≥{inviteRechargeThreshold}U và khối lượng giao dịch hợp đồng vĩnh cửu là ≥{contractVolumeThreshold}U.',
    businessRule2: '2. Yêu cầu về tiêu chuẩn để các thành viên trong nhóm chia sẻ quỹ giải thưởng: Tham gia đoán mò ≥ {quizTimesThreshold} lần trong thời gian diễn ra sự kiện + khối lượng giao dịch hợp đồng vĩnh cửu ≥ {poolContractThreshold}U',
    businessRule3: '3. Điểm cá nhân có thể được quy đổi thành quà tặng bất cứ lúc nào. Sau khi quy đổi, điểm cá nhân và điểm đội tương ứng sẽ bị trừ.',
    businessRule4: '4. Số lượng giải thưởng vật chất có hạn và phải được đổi khi còn hàng.',
    businessRule5: '5. Thời hạn đổi vé World Cup là trước ngày khai mạc World Cup. Nếu vé cứng không thể đổi được do trường hợp bất khả kháng, chúng có thể được đổi lấy USDT tương đương.',
    statementTitle: 'tuyên bố trang trọng',
    statement1: '1. Mỗi người dùng chỉ được sử dụng một tài khoản để tham gia hoạt động. Nghiêm cấm sử dụng nhiều tài khoản (bao gồm nhưng không giới hạn tài khoản đăng ký hàng loạt, tài khoản liên kết, v.v.) để tham gia các hoạt động. Hệ thống sẽ giám sát các thiết bị đăng nhập và địa chỉ IP của các tài khoản tham gia. Nếu nhiều tài khoản được phát hiện đang hoạt động trên cùng một thiết bị hoặc cùng một địa chỉ IP, nền tảng có quyền xác định tài khoản đó là tài khoản có liên quan;',
    statement2: '2. Hành vi giao dịch của người dùng tham gia hoạt động phải đúng sự thật và hợp lệ, nghiêm cấm mọi hình thức giao dịch ngược chiều, giao dịch ngược chiều hoặc tự giao dịch.',
    statement3: '3. Nền tảng sẽ xác định các hành vi giao dịch bất thường thông qua hệ thống kiểm soát rủi ro, bao gồm nhưng không giới hạn ở: mở và đóng vị thế đảo ngược tần suất cao, giao dịch phòng ngừa rủi ro ở cùng mức giá và hành vi rửa chênh lệch giá rủi ro thấp.',
    statement4: '4. Sau khi phát hiện hành vi giao dịch bất thường, nền tảng có quyền: xóa số điểm được tạo ra bởi phần giao dịch này, hủy tư cách tham gia các hoạt động của người dùng, đóng băng hoặc rút các phần thưởng liên quan',
    statement5: '5. Số tiền thưởng và phân bổ phần thưởng phải tuân theo kết quả thống kê cuối cùng của nền tảng. Nền tảng có quyền giải thích cuối cùng về các quy tắc của sự kiện này.',
  },
  exchange: {
    needPoints: 'Điểm yêu cầu',
    stock: 'hàng còn lại',
    buyNow: 'Đổi ngay bây giờ',
    soldOut: 'Bán hết',
    badgeUnique: 'Giải thưởng lớn duy nhất trên trang web',
    badgeOnlyCount: 'Chỉ {count} chiếc',
    itemFinalTicket: 'Vé xem trận chung kết World Cup',
    itemSignedFootball: 'bóng đá có chữ ký',
  },
  task: {
    earnPoints: 'Kiếm điểm',
    goFinish: 'để hoàn thành',
    goTeamTask: 'Làm nhiệm vụ để nhận điểm đội',
  },
  taskGroup: {
    daily: 'công việc hàng ngày',
    invite: 'Mời nhiệm vụ',
    recharge: 'Nhiệm vụ nạp tiền',
    teamTrade: 'Nhiệm vụ giao dịch nhóm',
    dailyLimitPrefix: 'Giới hạn phần thưởng hàng ngày',
    teamLimitPrefix: 'Giới hạn phần thưởng hàng ngày của đội',
    limitPoints: '{num} điểm',
    limitSuffix: ', được làm mới hàng ngày lúc 00:00:00 (GMT+08:00)',
    rechargeLimitSuffix: 'Chỉ lần nạp tiền đầu tiên trong thời gian diễn ra sự kiện mới được tính để xem nó có đáp ứng tiêu chuẩn hay không.',
    inviteCta: 'Mời ngay bây giờ và kiếm điểm',
    taskPredictOnce: 'Mỗi khi bạn tham gia cá cược sự kiện',
    taskTrade10000: 'Mỗi khối lượng giao dịch hợp đồng vĩnh cửu hoàn thành tích lũy là {tradeVolume}U',
    taskInviteValidUser: 'Mỗi lần lời mời người dùng hợp lệ được hoàn thành',
    taskInviteRegister: 'Mời bạn bè đăng ký',
    taskInviteKyc: 'Mời bạn bè hoàn thành KYC',
    taskInviteRecharge: 'Mời bạn bè hoàn thành lần nạp tiền đầu tiên',
    taskFirstRecharge: 'Nạp tiền đầu tiên >= {amount} USDT',
    taskTeamTrade10000: 'Với mỗi khối lượng giao dịch hợp đồng vĩnh cửu tích lũy {tradeVolume} USDT được hoàn thành, nhóm sẽ nhận được +{teamBonusPoints} điểm.',
  },
};
export {
  apis,
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/vi.js